import React from "react";
import ReactDOM from 'react-dom';
import http from '../modules/api';

import TextInput from "../modules/common/TextInput";
import SelectBoxV2 from '../modules/common/SelectBoxV2';
import SaveDialogV2 from '../modules/dialogs/SaveDialogV2';
import BasicDialogV2 from "../modules/dialogs/BasicDialogV2";
import WarningDialog from "../modules/dialogs/WarningDialog";
import ConfirmDialogV2 from '../modules/dialogs/ConfirmDialogV2';
import TitleContentDialogV2 from '../modules/dialogs/TitleContentDialogV2';
import RoboImgSettingPopup from '../autoEvent/component/RoboImgSettingPopup';
import RoboImageStudioTabs from "../autoEvent/component/RoboImageStudioTabs";
import AiImageStudioWorkflowClass from "../modules/common/AiImageStudioWorkflowClass";
import SearchProductPopup from '../modules/popup/SearchProductPopup';
import PopupFrameV2 from '../modules/popup/PopupFrameV2';
import CheckBox from "../modules/common/CheckBox";
import InstagramTemplateEditor from "./InstagramTemplateEditor";
import ModalSizeSelect from "./component/ModalSizeSelect"; 
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'

import AICopywriterModal from './component/AICopywriterModal';

import * as StringUtil from '../modules/utils/StringUtil';

import DatePicker from "react-datepicker";
import { ko } from "date-fns/locale";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";

import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors
} from "@dnd-kit/core";
import {
  arrayMove as arraymMoveByDndKit,
  SortableContext,
  useSortable,
  rectSortingStrategy
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Copy } from "lucide-react";

const sensors = [
  {
    sensor: PointerSensor,
    options: {
      activationConstraint: {
        delay: 0,
        tolerance: 5,
      },
    },
  },
];

const _ = require('lodash');

const FACEBOOK_APP_ID = '780456611206591';
const BASEDOMAIN = document.domain.indexOf("127.0.0.1") >= 0 ? 'https://127.0.0.1:8092' : "https://robomd.io";
const REDIRECT_URI = BASEDOMAIN + '/rest/shop/instagram/callbackForRefleshParent';
const SCOPES = [
  'pages_show_list',
  'business_management',
  'instagram_basic',
  'instagram_content_publish',
  'instagram_manage_insights',
  'public_profile'
].join(',');

// 1) 개별 태그: useSortable 적용 (기존 스타일 유지하되 HTML 칩 스타일도 일부 차용)
function SortableTag({ id, onRemove, children }) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

  const style = {
    transform: transform
      ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
      : undefined,
    transition,
  };

  return (
    <span
      ref={setNodeRef}
      className="phrase-chip"
      style={{
        ...style,
        cursor: "grab",
        background: "#f0fdfe",
        borderColor: "#00e2e6",
        color: "#0d9488"
      }}
      {...attributes}
      {...listeners}
    >
      {children}
      <span
        className="chip-delete"
        onClick={onRemove}
        onPointerDown={(e) => e.stopPropagation()}
        title="삭제"
      >
        ×
      </span>
    </span>
  );
}

export default class InstagramCreatePost_v2 extends React.Component {
  constructor(props) {
    super(props);
    this.captionTextareaRef = React.createRef();
    this.fileInputRef = React.createRef();
    this.scrollAreaRef = React.createRef();
    this.pickerRef = React.createRef();
    this.triggerRef = React.createRef();
    this.inputHashtagRef = React.createRef();
    this.isComposing = false;

    this.state = {
      // 스크롤 스파이 상태
      activeSection: 'sec-image',

      // [NEW] HTML 추가 요소 상태 관리
      quickPhrases: [
        // { title: '📩 문의안내', content: '\n📩 문의는 언제든 DM 주세요!' }
      ],
      fixedTags: [
        // {favorite_tag_seq: '-1',tag_name: '#로보MD'}, {favorite_tag_seq: '-2',tag_name: '#의료AI'}
      ],
      modals: {
        styleConfig: false,
        captionSettings: false,
        hashtagSettings: false,
        phrase: false,
        addTag: false
      },
      phraseTitleInput: "",
      phraseContentInput: "",
      newFixedTagInput: "",

      // 기존 상태값들
      isSizeModalOpen: false,
      add_account_list: [],
      selected_account_list : [],
      currentStep: 1, 
      accountConnected: false,
      selectedAccount: {},
      selectedFeedType: "SINGLE",
      imageSlots: [{ type: null, data: null }],
      imageModalOpen: false,
      currentImageSlotIndex: 0,
      caption_history: [],
      caption_future: [],
      caption: "",
      topicInput: "",
      aiSuggestionsVisible: false,
      inputHashtagValue: "",
      tags: [],
      previewSlideIndex: 0,
      publishOption: "NOW",
      scheduledDate: "",
      scheduledTime: "00:00",
      save_dialog_show_state: false,
      save_dialog_content: "로딩중 입니다.",
      save_dialog_button_list: [{ title: "확인", type: "1", display_yn:"N" }],
      confirm_dialog_show_state : false,
      confirm_dialog_content : "",
      confirm_dialog_button_list : [],
      basic_dialog_show_state: false,
      basic_dialog_content: "",
      basic_dialog_button_list: [{title:"확인", event_method:()=>{this.setState({basic_dialog_show_state:false})}}],
      warning_dialog_show_state: false,
      warning_dialog_content: "",
      warning_dialog_button_list: [{title:"확인", event_method:()=>{this.setState({warning_dialog_show_state:false})}}],
      emojiPickerVisible: false,
      selected_event_seq: "",

      hashtag_setting_count: 5,
      caption_setting_count: 3,
      is_auto_hashtag_on: false,

      hideAccountBanner: false,

      selectedStyleConfig: {},

      gptUsageLoading: false,
      gptUsage: {
        total_available_gpt_char_count: 0,
        total_used_gpt_char_count: 0,
        max_available_gpt_char_count: 0,
        is_api_limit_apply_yn: "N",
      },
    };
  }

  componentDidMount() { 
    this.instagramFreePreriod();
    this.loadNewFixedTagList();
    this.loadQuickPhrases();
    this.loadGenerationCount();
    this.loadGptUsage();
    const mediaId = StringUtil.getUrlParams('media_id');
    this.setState({ media_id: mediaId });

    this.loadInstagramAccountList();

    const { scheduledDate, scheduledTime } = this.state;
    if (scheduledDate && scheduledTime) {
      const init = new Date(`${scheduledDate}T${scheduledTime}:00`);
      this.setState({ scheduledAt: init });
    }

    if (mediaId) {
      this.loadInstagramMediaDetail(mediaId);
    }

    const options = { root: this.scrollAreaRef.current, threshold: 0.3 };
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          this.setState({ activeSection: entry.target.id });
        }
      });
    }, options);

    document.addEventListener('mousedown', this.handleClickOutside);

    window.addEventListener('message', this.handleInstagramMessage);
    window.addEventListener("message", this.handleMessage); 
  }

  componentDidUpdate(prevProps, prevState) {
    const prevCnt = (prevState.imageSlots || []).filter(s => s && s.type && s.data).length;
    const currCnt = (this.state.imageSlots || []).filter(s => s && s.type && s.data).length;
    if (prevCnt !== currCnt) {
      const total = currCnt || 1;
      const idx = this.state.previewSlideIndex || 0;
      const fixed = ((idx % total) + total) % total;
      if (fixed !== idx) {
        this.setState({ previewSlideIndex: fixed });
      }
    }

    if(this.state.show_add_product_popup) {
        document.body.style.overflow = 'hidden'; 
    } else {
        document.body.style.overflow = 'auto'; 
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    window.removeEventListener('message', this.handleInstagramMessage);
    window.removeEventListener("message", this.handleMessage);

    if (this.observer) {
        this.observer.disconnect();
    }
  }

  loadGptUsage = () => {
    this.setState({ gptUsageLoading: true });

    http.get("/rest/shop/ai/usage", {
      params: {
        service_type: "01014",
      }
    })
    .then((res) => {
      const data = res.data || {};

      this.setState({
        gptUsageLoading: false,
        gptUsage: {
          total_available_gpt_char_count: data.total_available_gpt_char_count || 0,
          total_used_gpt_char_count: data.total_used_gpt_char_count || 0,
          max_available_gpt_char_count: data.max_available_gpt_char_count || 0,
          is_api_limit_apply_yn: data.is_api_limit_apply_yn || "N",
        },
      });
    })
    .catch((err) => {
      console.error("GPT 사용량 조회 실패:", err);
      this.setState({ gptUsageLoading: false });
    });
  };

  handleInstagramMessage = (e) => {
    if (e.data && e.data.type == 'refreshInstagramAccount') {
      if (e.data.token_id) {
        this.loadInstagramAccountList(e.data.token_id);
        this.setState({
          token_id: e.data.token_id,
          show_account_connect_popup: true
        });
      }
    }
  };

  handleMessage = (event) => {
    if(event.data.type === "cnt_setting_saved"){
      this.loadGenerationCount();
    }
  }


  scrollToSec = (id) => {
    const target = document.getElementById(id);
    if(target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    this.setState({ activeSection: id });
  };

  // [NEW] 모달 토글 로직
  toggleModal = (modalName, isOpen) => {
    this.setState(prev => ({
        modals: { ...prev.modals, [modalName]: isOpen }
    }));
  }

  goToSettings = (modalName) => {
    // alert('AI 자동 환경설정 페이지로 이동합니다.');
    this.toggleModal(modalName, false);
    window.open('/shop/instagram/InstagramCreateCntSetting');
  }

  // [NEW] 고정 문구 로직
  appendPhraseText = (text) => {
      if (this.state.caption.length > 0) {
        this.setCaption(this.state.caption + "\n" + text);
      } else {
        this.setCaption(this.state.caption + text);
      }
  }

  addNewPhrase = () => {
      const { phraseTitleInput, phraseContentInput, quickPhrases } = this.state;
      if(!phraseTitleInput.trim() || !phraseContentInput.trim()) {
          alert('제목과 내용을 모두 입력해주세요.');
          return;
      }
      this.toggleModal('phrase', false);
      this.addNewPhraseByAPI();
  }

  removePhrase = async (index) => {
      // 지워질 객체를 미리 참조해 둠 (복구를 위해 전체 정보 보존)
      const phraseToDelete = this.state.quickPhrases[index];

      if (phraseToDelete.favorite_phrase_seq && String(phraseToDelete.favorite_phrase_seq).startsWith('temp_')) {
        return false;
      }

      const result = await this.openConfirmDialog({
        title: `<b>${phraseToDelete.title}</b> 고정문구를 삭제하시겠습니까?`,
      });

      if (!result) {
          return false;
      }
      
      // 1. 화면(UI)에서 먼저 삭제 (Optimistic Update)
      this.setState(prev => {
          const newPhrases = [...prev.quickPhrases];
          newPhrases.splice(index, 1);
          return { quickPhrases: newPhrases };
      });

      // 2. 서버에서 지우기 
      // 서버 통신 함수에 '삭제된 객체'와 '원래 위치(index)'를 함께 전달합니다.
      this.removePhraseByAPI(phraseToDelete, index);
  }

  // [삭제 API 및 복구 로직]
  removePhraseByAPI = async (deletedPhrase, originalIndex) => {
      http.delete(`/rest/shop/favorite-phrases/${deletedPhrase.favorite_phrase_seq}`)
      .then(res => {
          if (res.data.status === 'success') {
              // 성공 시 이미 화면(UI)에서 지워뒀으므로, 더 이상 setState로 지우지 않습니다. (UI 2중 삭제 방지)
              console.log("고정문구 삭제 완료");
          } else {
              // 논리적 실패(status가 success가 아님)일 경우 강제로 에러를 발생시켜 catch 블록으로 보냅니다.
              throw new Error(res.data.message || "삭제 처리 실패");
          }
      })
      .catch(err => {
          console.error("고정문구 삭제 중 오류 발생:", err);
          // alert("삭제에 실패했습니다. 원래 상태로 복구됩니다.");
          
          // [데이터 원복(Rollback) 로직]
          // 에러가 발생하면, 삭제했던 객체를 원래 위치(originalIndex)에 다시 끼워 넣습니다.
          this.setState(prev => {
              const restoredPhrases = [...prev.quickPhrases];
              restoredPhrases.splice(originalIndex, 0, deletedPhrase);
              return { quickPhrases: restoredPhrases };
          });
      });
  }
  
  removePhraseHashtag = async (index) => {
      // 지워질 객체를 미리 참조해 둠 (복구를 위해 전체 정보 보존)
      const tagToDelete = this.state.fixedTags[index];

      if (tagToDelete.favorite_tag_seq && String(tagToDelete.favorite_tag_seq).startsWith('temp_')) {
        return false;
      }
      
      const result = await this.openConfirmDialog({
        title: `<b>${tagToDelete.tag_name}</b> 태그를 삭제하시겠습니까?`,
      });

      if (!result) {
          return false;
      }
      
      // 1. 화면(UI)에서 먼저 지우기
      this.setState(prev => {
          const newTags = [...prev.fixedTags];
          newTags.splice(index, 1);
          return { fixedTags: newTags };
      });

      // 2. 서버에서 지우기
      // 복구를 위해 '삭제된 객체'와 '원래 위치(index)'를 함께 넘겨줍니다.
      this.deleteFavoriteHashtag(tagToDelete, index);
  }

  // [해시태그 삭제 API 및 복구 로직]
  deleteFavoriteHashtag = async (deletedTag, originalIndex) => {
      http.delete("/rest/shop/favorite-hashtags/" + deletedTag.favorite_tag_seq)
      .then(res => {
          // 삭제 성공 여부 확인
          if (res.data.status === 'success') {
              console.log("해시태그 삭제 완료");
          } else {
              // 논리적 실패 시 강제로 catch 블록으로 보냅니다.
              throw new Error(res.data.message || "삭제 처리 실패");
          }
      })
      .catch(error => {
          console.error("해시태그 삭제 중 오류 발생:", error);
          // alert("해시태그 삭제에 실패했습니다. 원래 상태로 복구됩니다.");
          
          // [데이터 원복(Rollback) 로직]
          this.setState(prev => {
              const restoredTags = [...prev.fixedTags];
              restoredTags.splice(originalIndex, 0, deletedTag);
              return { fixedTags: restoredTags };
          });
      });
  }
  
  // [NEW] 고정 해시태그 로직
  addNewFixedTag = () => {
      let val = this.state.newFixedTagInput.trim();
      if(!val) {
          alert('해시태그를 입력해주세요.');
          return;
      }
      if(!val.startsWith('#')) val = '#' + val;
      
      this.toggleModal('addTag', false);
      this.addFavoriteHashtag(val);
  }

  removeFixedTag = (index) => {
      this.setState(prev => {
          const newTags = [...prev.fixedTags];
          newTags.splice(index, 1);
          return { fixedTags: newTags };
      });
  }

  // --- 비즈니스 로직 ---
  loadInstagramAccountList = (token_id) => {
    const url = token_id
      ? `/rest/shop/instagram/profile/list?token_id=${token_id}`
      : "/rest/shop/instagram/profile/list";

    http.get(url)
      .then((res) => {
        const list = Array.isArray(res?.data?.list) ? res.data.list : [];
        const account_list_v2 = this.buildIgAccountOptionsV2(list);
        const defaultSeq = this.buildIgDefaultAccount(list) || "";

        const currentSelected = this.state.selected_ig_access_seq || "";

        const nextSelected =
          currentSelected &&
          currentSelected !== "none" &&
          currentSelected !== "add"
            ? currentSelected
            : defaultSeq;

        const targetAcc =
          (account_list_v2 || []).find(
            (acc) => String(acc.value) === String(nextSelected)
          ) || null;

        this.setState({
          add_account_list: list,
          account_list_v2,
          default_ig_access_seq: defaultSeq,
          accountConnected: account_list_v2.length > 0,
          selected_ig_access_seq: nextSelected || "",
          selectedAccount: targetAcc,
        });
      })
      .catch((error) => {
        console.error(error);
        this.setState({
          add_account_list: [],
          account_list_v2: [],
          default_ig_access_seq: "",
          accountConnected: false,
          selected_ig_access_seq: "",
          selectedAccount: null,
        });
      });
  };

  loadInstagramMediaDetail = async (mediaId, blocked_load_dialog = false) => {
    if (!mediaId) return;
    try {
      if (blocked_load_dialog !== true) {
        this.setState({ save_dialog_show_state: true, save_dialog_content: "게시물 불러오는 중..." });
      }

      const { data: res } = await http.get(`/rest/shop/instagram/media/${mediaId}`);
      const r = res || {};

      if (r.status == "PUBLISHED") {
        alert("이미 발행된 게시물은 수정할 수 없습니다.");
        window.location.href = '/shop/instagram/InstagramPostList';
      }

      const items = Array.isArray(r.items) ? r.items : [];
      const imageSlots = items.map((it) => {
        const src = it.source || {};
        const type =
          src.source_type_cd === "U" ? "upload" :
          src.source_type_cd === "P" ? "product" :
          src.source_type_cd === "A" ? "ai" :
          src.source_type_cd === "T" ? "template" :
          (src.product_no ? "product" : "upload");

        return {
          type,
          data: src.source_url || it.preview_image_url || null,
          media_source_id: it.media_source_id || src.media_source_id || null,
          product_no: src.product_no || it.product_no || null,
          stability_call_seq: it.stability_call_seq || null,
          event_seq: src.event_seq || null,
          product_name: src.product_name || null,
        };
      });

      const normalizedSlots = this.normalizeImageSlots(imageSlots);
      const tags = Array.isArray(r.hashtags)
        ? r.hashtags
        : (typeof r.hashtags === "string" ? r.hashtags.split(/\s+/).filter(Boolean) : []);

      const scheduledRaw = r.scheduled_time || r.scheduled_at || "";
      let scheduledDate = "";
      let scheduledTime = "";
      if (scheduledRaw) {
        const iso = scheduledRaw.replace(" ", "T");
        const s = scheduledRaw.replace("T", " ");
        scheduledDate = s.slice(0, 10);
        scheduledTime = s.slice(11, 16);
      }

      const selectedFeedType = this.getFeedTypeBySlots(normalizedSlots);

      let parsedSuggestions = [];
      try {
        parsedSuggestions = r.gpt_caption_suggestions
          ? JSON.parse(r.gpt_caption_suggestions)
          : [];
      } catch (e) {
        console.error("gpt_caption_suggestions JSON 파싱 실패:", e);
        parsedSuggestions = [];
      }

      this.setState({
        media_id: r.instagram_media_seq || mediaId,
        selected_ig_access_seq: r.instagram_access_token_seq ? String(r.instagram_access_token_seq) : this.state.selected_ig_access_seq,
        imageSlots: normalizedSlots,
        tags,
        publishOption : r.post_type,
        scheduledDate,
        scheduledTime,
        is_draft: r.is_draft,
        status: r.status,
        selectedFeedType,
        previewSlideIndex: 0,
        aiSuggestionsVisible: parsedSuggestions.length > 0,
        topicInput: r.caption_prompt || "",
        aiRecommendations: r.gpt_caption_suggestions ? JSON.parse(r.gpt_caption_suggestions) : [],
        selectedLabel: r.gpt_caption_selected_suggestions || "",
        currentRatio: r.image_ratio || "1/1",
        copywriter_preset_seq: r.copywriter_preset_seq || "",
      });
      this.setCaption(r.caption || "");
      
    } catch (err) {
      console.error(err);
      this.setState({
        basic_dialog_show_state: true,
        basic_dialog_content: "게시물 불러오기에 실패했습니다.",
      });
    } finally {
      this.setState({ save_dialog_show_state: false });
    }
  }

  buildIgAccountOptions(apiPayload) {
    const src = apiPayload && (apiPayload.list || apiPayload) || [];
    const opts = [];
    src.forEach(fb => {
      const fbName = fb.facebook_username || "(이름 없음)";
      const igList = fb.instagram_account_list || [];
      igList.forEach(ig => {
        const v = String(ig.instagram_access_token_seq ?? "");
        if (!v) return;
        const uname = ig.username ? `@${ig.username}` : "(계정명 없음)";
        opts.push({ value: v, title: `${fbName} / ${uname}` });
      });
    });
    return opts;
  }

  buildIgAccountOptionsV2(apiPayload) {
    const src = apiPayload && (apiPayload.list || apiPayload) || [];
    const opts = [];
    src.forEach(fb => {
      const igList = fb.instagram_account_list || [];
      igList.forEach(ig => {
        const v = String(ig.instagram_access_token_seq ?? "");
        if (!v) return;
        const uname = ig.username ? `${ig.username}` : "(계정명 없음)";
        opts.push({ value: v, title: `${uname}`, profile_picture_url: ig.profile_picture_url || null });
      });
    });
    return opts;
  }

  buildIgDefaultAccount(apiPayload) {
    const src = (apiPayload && (apiPayload.list || apiPayload)) || [];
    
    // 1. 모든 facebook 객체에서 instagram_account_list를 추출하여 하나의 배열로 만듭니다.
    const allIgAccounts = src.reduce((acc, fb) => {
        return acc.concat(fb.instagram_account_list || []);
    }, []);

    if (allIgAccounts.length === 0) return "";

    // 2. 전체 배열에서 default_yn === 'Y'인 것을 찾습니다.
    const defaultAcc = allIgAccounts.find(ig => ig.default_yn === 'Y');

    // 3. 찾았다면 그 시퀀스를 반환, 없다면 배열의 첫 번째 계정을 반환합니다.
    if (defaultAcc) {
        return String(defaultAcc.instagram_access_token_seq ?? "");
    } else {
        return String(allIgAccounts[0].instagram_access_token_seq ?? "");
    }
  }

  onChangeAccount = (text, value) => {
    // 1. "연동하기" 버튼을 눌렀을 때
    if (value === 'add') {
      alert('계정 관리/연동 페이지로 이동합니다.');
      this.handleConnectAccount(); // 기존에 구현되어 있는 페이스북/인스타 연동 함수 실행
      // (SelectBox의 값은 변하지 않도록 여기서 중단)
      return;
    }

    // 2. "계정 미연동"을 선택했을 때
    if (value === 'none') {
      this.setState({ 
        selected_ig_access_seq: 'none', 
        selectedAccount: null 
      });
      return;
    }

    // 3. 정상적으로 연결된 계정을 선택했을 때
    const targetAcc = (this.state.account_list_v2 || []).find(acc => acc.value == value);
    this.setState({ 
      selected_ig_access_seq: value,
      selectedAccount: targetAcc || null,
    });
  };

  selectFeedType = (type) => {
    if (type === "SINGLE") {
      this.setState({
        selectedFeedType: "SINGLE",
        imageSlots: [this.state.imageSlots[0] || { type: null, data: null }],
      });
    } else if (type === "REELS") {
      this.setState({ selectedFeedType: "REELS" });
    } else {
      this.setState({ selectedFeedType: "CAROUSEL" });
    }
  };

  addNewImageSlot = () => {
    this.setState((prev) => {
      if (prev.imageSlots.length >= 10) {
        alert("최대 10개까지만 추가할 수 있습니다.");
        return null;
      }
      return { imageSlots: [...prev.imageSlots, { type: null, data: null }] };
    });
  };

  isFilledSlot = (slot) => {
    return !!(slot && slot.type && slot.data);
  };

  getFilledSlotCount = (imageSlots = []) => {
    return imageSlots.filter((slot) => this.isFilledSlot(slot)).length;
  };

  getFeedTypeBySlots = (imageSlots = []) => {
    return this.getFilledSlotCount(imageSlots) >= 2 ? "CAROUSEL" : "SINGLE";
  };

  normalizeImageSlots = (imageSlots = []) => {
    const filledSlots = imageSlots.filter((slot) => this.isFilledSlot(slot)).slice(0, 10);

    if (filledSlots.length >= 10) {
      return filledSlots;
    }

    return [...filledSlots, { type: null, data: null }];
  };

  updateImageSlotsState = (updater, callback) => {
    this.setState((prev) => {
      const draftSlots =
        typeof updater === "function"
          ? updater([...(prev.imageSlots || [])], prev)
          : updater;

      const normalizedSlots = this.normalizeImageSlots(draftSlots);
      const nextFeedType = this.getFeedTypeBySlots(normalizedSlots);

      return {
        imageSlots: normalizedSlots,
        selectedFeedType: nextFeedType,
      };
    }, callback);
  };

  isAllImageSlotsEmpty = () => {
    const { imageSlots } = this.state;
    return (imageSlots || []).every((slot) => !this.isFilledSlot(slot));
  };
  

  openImageModal = (index, slot_type) => {
    if (slot_type === "template") {
      this.setState({ show_design_template_popup: true, selected_event_seq: (this.state.imageSlots[index].event_seq || ""), currentImageSlotIndex: index });
    } else {
      if (this.isAllImageSlotsEmpty()) {
        this.setState({ isSizeModalOpen: true, currentImageSlotIndex: index });
      } else {
        this.setState({ imageModalOpen: true, currentImageSlotIndex: index });
      }
    }
  };

  closeImageModal = () => {
    this.setState({ imageModalOpen: false });
  };

  handleImageSource = (source, event_seq) => {
    const idx = this.state.currentImageSlotIndex;
    if (source === "upload") {
      if (this.fileInputRef.current) {
        this.fileInputRef.current.onchange = async (e) => {
          const file = e.target.files && e.target.files[0];
          if (!file) return;
          this.saveS3Image(idx, file);
        };
        this.fileInputRef.current.click();
      }
    } else if (source === "product") {
      this.setState({ show_add_product_popup: true }, () => {
        this.closeImageModal();
      });
    } else if (source === "ai") {
      this.setState({ show_robo_img_popup: true}, () => {
        this.closeImageModal();
      });
    } else if (source === "template") {
      this.setState({ show_design_template_popup: true,  selected_event_seq: "" }, () => {
        this.closeImageModal();
      });
    } else {
      this.updateImageSlotsState((imageSlots) => {
        imageSlots[idx] = { type: source, data: null };
        return imageSlots;
      });
    }
    this.closeImageModal();
  };

  deleteImageAt = (e, index) => {
    e.stopPropagation();

    this.updateImageSlotsState((imageSlots) => {
      imageSlots.splice(index, 1);
      return imageSlots;
    }, () => {
      if (this.fileInputRef?.current) this.fileInputRef.current.value = "";
    });
  };

  saveS3Image = (idx, file) => {
    this.setState({ save_dialog_show_state: true });
    const config = { headers: { 'Content-Type': 'multipart/form-data' } }
    const formData = new FormData();
    formData.append("files", file);
    formData.append("ratio", this.state.currentRatio ? this.state.currentRatio : "1/1");
        
    http.post("/rest/shop/instagram/resizeOrgImg", formData, config)
    .then(res => {
        const url = res.data.org_img_path;
        this.updateImageSlotsState((imageSlots) => {
          imageSlots[idx] = { type: "upload", data: url };
          return imageSlots;
        }, () => {
          if (this.fileInputRef?.current) this.fileInputRef.current.value = "";
        });
        this.setState({ save_dialog_show_state: false });
      }).catch(error => {
        console.log (error);
        this.setState({ save_dialog_show_state: false });
      })
  }

  onChangeCaption = (e) => this.setCaption(e.target.value);

  showEmojiPicker = () => {
    this.setState((prev) => ({ emojiPickerVisible: !prev.emojiPickerVisible }));
  };

  handleEmojiSelect = (emoji) => {
    const textarea = this.captionTextareaRef.current;
    if (!textarea) return;
    const { selectionStart, selectionEnd } = textarea;
    const before = this.state.caption.slice(0, selectionStart);
    const after = this.state.caption.slice(selectionEnd);
    const newCaption = before + emoji.native + after;

    this.setCaption(newCaption, () => {
      const pos = selectionStart + emoji.native.length;
      textarea.selectionStart = textarea.selectionEnd = pos;
      textarea.focus();
    });
    this.setState({ emojiPickerVisible: false });
  };

  useSuggestion = (label) => {
    const { aiRecommendations = [] } = this.state;
    const found = aiRecommendations.find((r) => r.label === label);
    const text = found?.text?.trim?.() || "문구를 찾지 못했어요.";
    this.setCaption(text);
    this.setState({ selectedLabel: label, aiSuggestionsVisible: true });
  };

  generateAICaption = async () => {
    const { topicInput, imageSlots = [] } = this.state;
    const productNameList = imageSlots
      .filter((s) => s && s.type === "product" && s.product_name)
      .map((s) => s.product_name);

    this.setState({
      save_dialog_show_state: true,
      save_dialog_content: "인공지능이 추천문장을 생성중입니다."
    });

    try {
      const { data } = await http.post(
        "/rest/shop/instagram/GptRecommamdSentence",
        {
          create_cnt: this.state.caption_setting_count ? this.state.caption_setting_count : 3,
          product_name_list: productNameList.map((x) => x.trim()),
          user_prompt: topicInput,
          copywriter_preset_seq: this.state.copywriter_preset_seq || null,
          image_list: imageSlots.map(it => it.data).filter(Boolean),
        },
        { headers: { "Content-Type": "application/json" } }
      );

      const recommendations = Array.isArray(data?.recommendations)
        ? data.recommendations
        : [];

      this.setState((prevState) => {
        const hasCaption = !!(prevState.caption && prevState.caption.trim());
        const firstRecommendationText = recommendations[0]?.text || "";
        const firstRecommendationLabel = recommendations[0]?.label || "";

        return {
          caption: hasCaption ? prevState.caption : firstRecommendationText,
          selectedLabel: hasCaption ? prevState.selectedLabel : firstRecommendationLabel,
          aiSuggestionsVisible: true,
          aiRecommendations: [
            ...(prevState.aiRecommendations || []),
            ...recommendations
          ],
          save_dialog_show_state: false,
          gpt_caption_seq: data?.gpt_call_seq || null,

          gptUsage: {
            total_available_gpt_char_count: data?.total_available_char_count || prevState.gptUsage.total_available_gpt_char_count || 0,
            total_used_gpt_char_count: data?.total_used_char_count || prevState.gptUsage.total_used_gpt_char_count || 0,
            max_available_gpt_char_count: data?.max_available_char_count || prevState.gptUsage.max_available_gpt_char_count || 0,
            is_api_limit_apply_yn: prevState.gptUsage.is_api_limit_apply_yn || "N",
          }
        };
      });

      if (this.state.is_auto_hashtag_on) {
        this.generateAIHashtags();
      }
    } catch (err) {
      console.error("AI 추천문 생성 실패:", err);
      alert("추천 문장 생성에 실패했습니다. 잠시 후 다시 시도해주세요.");
      this.setState({ save_dialog_show_state: false });
    } finally {
      // 혹시 응답에 usage 값이 안 왔을 때를 대비해 한 번 더 동기화
      this.loadGptUsage();
    }
  };
  
  generateAIHashtags = async () => {
    // fixedTags, manualTags 대신 실제 적용 중인 tags 배열을 가져옵니다.
    const { caption, tags } = this.state;
    
    if (!caption || !caption.trim()) {
      alert("피드 문구를 입력해주세요.\n(문구를 기반으로 해시태그를 생성합니다.)");
      return;
    }
    
    this.setState({ save_dialog_show_state: true, save_dialog_content: "인공지능이 해시태그를 생성중입니다..."  });

    try {
      const { data } = await http.post("/rest/shop/instagram/GptRecommamdHashtag",
        // 이미 본문에 추가된 태그들(tags)을 전달하여 중복 추천을 방지
        { create_cnt : this.state.hashtag_setting_count ? this.state.hashtag_setting_count: 5, user_prompt: caption, alreadyUsedHashtags: tags },
        { headers: { "Content-Type": "application/json" } }
      );
      
      const hashtags = Array.isArray(data?.hashtags) ? data.hashtags : [];
      
      // AI가 생성한 태그를 실제 화면에 렌더링되는 tags 배열에 직접 병합 (중복 방지 로직 포함)
      this.setState(prev => {
        const newTags = [...prev.tags];
        hashtags.forEach(tag => {
            if (!newTags.includes(tag)) {
                newTags.push(tag);
            }
        });
        return {
          tags: newTags,
          gpt_hashtag_seq : data?.gpt_call_seq || null,
        };
      });
      
    } catch (err) {
      console.error("AI 해시태그 생성 실패:", err);
      alert("추천 해시태그 생성에 실패했습니다. 잠시 후 다시 시도해주세요.");
    } finally {
      this.setState({ save_dialog_show_state: false });
      
      // 혹시 응답에 usage 값이 안 왔을 때를 대비해 한 번 더 동기화
      this.loadGptUsage();
    }
  };

  onChangeTopic = (e) => this.setState({ topicInput: e.target.value });

  addHashtagOnEnter = (e) => {
    if (e.key === "Enter") {
      if (this.isComposing) return;
      e.preventDefault();
      let valueRaw = e.target.value.trim();
      if (!valueRaw) return;
      valueRaw = this.sanitizeHashtag(valueRaw);
      const value = valueRaw.startsWith("#") ? valueRaw : `#${valueRaw}`;
      this.setState((prev) => {
        if (prev.tags.includes(value)) return null;
        return { tags: [...prev.tags, value], inputHashtagValue: "" };
      });
      e.target.value = "";
    }
  };

  // sanitizeHashtag = (raw) => {
  //   const value = raw.replace(/[^A-Za-z0-9ㄱ-ㅎㅏ-ㅣ가-힣_]/g, '');
  //   return raw.startsWith("#") ? `#${value}` : value;
  // };

  sanitizeHashtag = (raw) => {
    return raw
      .split(' ') // 1. 띄어쓰기 기준으로 각 태그를 나눔
      .map((tag) => {
        // 2. 빈 문자열(연속된 공백) 방지
        if (!tag) return ''; 

        const hasHash = tag.startsWith('#');
        
        // 3. '#'를 제외하고 허용된 문자만 남김
        // (정규식에서 '#'이 포함되지 않았으므로, 여기서 '#'이 같이 제거되지 않게 주의)
        const cleanContent = tag.replace(/[^A-Za-z0-9ㄱ-ㅎㅏ-ㅣ가-힣_]/g, '');
        
        // 4. 원래 '#'가 있었다면 다시 붙여줌
        return hasHash ? `#${cleanContent}` : cleanContent;
      })
      .filter((tag) => tag !== '') // 5. 중간에 발생한 빈 값 제거
      .join(' '); // 6. 다시 띄어쓰기로 합침
  };


  handlePasteHashtag = (e) => {
    e.preventDefault();
    const paste = (e.clipboardData || window.clipboardData).getData("text");
    const noSpace = paste.replace(/\s+/g, "");
    const target = e.target;
    let newValue = this.sanitizeHashtag(noSpace);
    target.value = newValue;
  };

  removeTagAt = (i) => {
    this.setState((prev) => {
      const tags = [...prev.tags];
      tags.splice(i, 1);
      return { tags };
    });
  };

  selectPublishOption = (type) => this.setState({ publishOption: type });
  onChangeDatePicker = (date) => this.setState({ scheduledDate: date ? format(date, "yyyy-MM-dd") : "" });
  onChangeTimePicker = (date) => this.setState({ scheduledTime: date ? format(date, "HH:mm") : "" });

  getDateObjForDate = () => {
    const { scheduledDate, scheduledTime } = this.state;
    if (!scheduledDate) return null;
    const time = scheduledTime || "00:00";
    return new Date(`${scheduledDate}T${time}:00`);
  };

  getDateObjForTime = () => {
    const { scheduledDate, scheduledTime } = this.state;
    const baseDate = scheduledDate ? scheduledDate : format(new Date(), "yyyy-MM-dd");
    const time = scheduledTime || "00:00";
    return new Date(`${baseDate}T${time}:00`);
  };

  // ==============================
  // 발행용 검증
  // - 즉시발행 / 예약발행 전용
  // ==============================
  validateForPublish = () => {
    const {
      publishOption,
      caption,
      tags,
      scheduledDate,
      scheduledTime,
      imageSlots,
      selectedFeedType,
    } = this.state;

    const igAccessSeq = this.getPublishAccountSeq();
    if (!this.isValidIgSeq(igAccessSeq)) {
      return "발행할 인스타그램 계정을 선택해주세요.";
    }

    const filled = (imageSlots || []).filter((s) => s && (s.media_source_id || s.data));
    if (filled.length === 0) {
      return "최소 한 개 이상의 이미지가 필요합니다.";
    }

    if (selectedFeedType === "CAROUSEL" && filled.length < 2) {
      return "슬라이드 이미지인 경우 최소 2개의 이미지가 필요합니다.";
    }

    // 릴스 검증 필요 시 여기 추가
    // if (selectedFeedType === "REELS") {
    //   return "릴스 검증 로직 추가";
    // }

    const itemError = this.validateItems(filled);
    if (itemError) {
      return itemError;
    }

    const {
      normalizedCaption,
      normalizedTags,
      tagCount,
      totalLength,
    } = this.getCaptionAndTagLengthInfo(caption, tags);

    if (!normalizedCaption) {
      return "캡션을 입력해주세요.";
    }

    if (tagCount > 30) {
      return `해시태그는 최대 30개까지만 등록할 수 있습니다.<br/>(현재 ${tagCount}개 작성)`;
    }

    if (totalLength > 2200) {
      return `본문과 해시태그를 합친 총 글자 수는<br/>2,200자를 초과할 수 없습니다.<br/>(현재 ${totalLength.toLocaleString()}자 작성)`;
    }

    if (publishOption === "SCHEDULED") {
      if (!scheduledDate || !scheduledTime) {
        return "날짜와 시간을 선택해주세요.";
      }

      const now = new Date();
      const scheduled = new Date(`${scheduledDate}T${scheduledTime}:00`);

      if (!(scheduled.getTime() > now.getTime())) {
        return "예약 시각은 현재보다 이후여야 합니다.";
      }

      // 최소 5분 이후만 허용하려면 사용
      // const minTime = new Date(Date.now() + 5 * 60 * 1000);
      // if (scheduled.getTime() <= minTime.getTime()) {
      //   return "예약 시각은 현재보다 최소 5분 이후여야 합니다.";
      // }
    }

    return "";
  };

  validateItems = (items) => {
    for (let i = 0; i < items.length; i++) {
      const item = items[i];

      if (!item.media_source_id && !item.data) {
        return `${i + 1}번 이미지가 비어있습니다.`;
      }

      if (!item.type) {
        return `${i + 1}번 이미지 타입이 없습니다.`;
      }

      // if (item.type === "ai" && !item.stability_call_seq) {
      //   return `${i + 1}번 AI 이미지 정보가 없습니다.`;
      // }

      if (item.type === "product" && !item.product_no) {
        return `${i + 1}번 상품 정보가 없습니다.`;
      }

      if (item.type === "template" && !item.event_seq) {
        return `${i + 1}번 템플릿 정보가 없습니다.`;
      }
    }

    return null;
  };


  // ==============================
  // 드래프트용 검증
  // - 임시저장은 느슨하게
  // ==============================
  validateForDraft = () => {
    const { caption, tags, imageSlots } = this.state;

    const filled = (imageSlots || []).filter((s) => s && (s.media_source_id || s.data));

    const itemError = this.validateItems(filled);
    if (itemError) {
      return itemError;
    }

    const { tagCount, totalLength } = this.getCaptionAndTagLengthInfo(caption, tags);

    if (tagCount > 30) {
      return `해시태그는 최대 30개까지만 등록할 수 있습니다.<br/>(현재 ${tagCount}개 작성)`;
    }

    if (totalLength > 2200) {
      return `본문과 해시태그를 합친 총 글자 수는<br/>2,200자를 초과할 수 없습니다.<br/>(현재 ${totalLength.toLocaleString()}자 작성)`;
    }

    return "";
  };

  getCaptionAndTagLengthInfo = (caption, tags) => {
    // 1. caption 정리
    const normalizedCaption = (caption || "").trim();

    // 2. tags 정리 (빈값 제거 + trim)
    const normalizedTags = (tags || [])
      .map(tag => (tag || "").trim())
      .filter(tag => tag.length > 0);

    // 3. 해시태그 개수
    const tagCount = normalizedTags.length;

    // 4. 해시태그 문자열
    const hashtagText = normalizedTags.join(" ");

    // 5. 총 길이 계산
    // caption + (공백 1개 + hashtags)
    const totalLength =
      normalizedCaption.length +
      (hashtagText.length > 0 ? hashtagText.length + 1 : 0);

    return {
      normalizedCaption,
      normalizedTags,
      tagCount,
      totalLength,
    };
  };

  publishPost = async () => {
    try {
      const validateMessage = this.validateForPublish();
      if (validateMessage) {
        this.setState({
          warning_dialog_show_state: true,
          warning_dialog_content: validateMessage
        });
        return;
      }

      const {
        publishOption,
        caption,
        tags,
        scheduledDate,
        scheduledTime,
        imageSlots,
        gpt_caption_seq,
        gpt_hashtag_seq,
        aiRecommendations,
        selectedLabel,
        media_id,
        selectedFeedType
      } = this.state;

      const igAccessSeq = this.getPublishAccountSeq();
      const filled = (imageSlots || []).filter((s) => s && (s.media_source_id || s.data));
      const { normalizedCaption, normalizedTags } = this.getCaptionAndTagLengthInfo(caption, tags);

      const items = filled.map((s, idx) => {
        if (s.media_source_id) {
          return {
            item_index: idx,
            is_cover_yn: idx === 0 ? "Y" : "N",
            media_source_id: s.media_source_id,
            event_seq: s.event_seq || null,
            preview_image_url: s.preview_image_url || null
          };
        }

        const typeCd =
          (s.type === "upload" && "U") ||
          (s.type === "product" && "P") ||
          (s.type === "ai" && "A") ||
          (s.type === "template" && "T") ||
          "U";

        return {
          item_index: idx,
          is_cover_yn: idx === 0 ? "Y" : "N",
          source_type_cd: typeCd,
          source_url: s.data,
          event_seq: s.event_seq || null,
          product_no: s.product_no || null,
          stability_call_seq: s.stability_call_seq || null
        };
      });

      const payload = {
        instagram_access_token_seq: igAccessSeq,
        caption: normalizedCaption,
        hashtags: normalizedTags,
        media_type_cd:
          selectedFeedType === "CAROUSEL"
            ? "C"
            : selectedFeedType === "REELS"
            ? "R"
            : "S",
        items,
        gpt_caption_seq: gpt_caption_seq || null,
        gpt_hashtag_seq: gpt_hashtag_seq || null,
        gpt_caption_suggestions: aiRecommendations ? JSON.stringify(aiRecommendations) : "[]",
        gpt_caption_selected_suggestions: selectedLabel || "",
        instagram_media_seq: media_id || null,
        image_ratio: this.state.currentRatio || "1/1",
        copywriter_preset_seq: this.state.copywriter_preset_seq || null,
      };

      if (publishOption === "SCHEDULED") {
        this.setState({
          save_dialog_show_state: true,
          save_dialog_content: "게시물 예약 중입니다."
        });

        payload.scheduled_at = `${scheduledDate}T${scheduledTime}`;

        const { data } = await http.post("/rest/shop/instagram/reservations", payload);

        this.setState({ save_dialog_show_state: false });

        if (!data || data.ok !== true) {
          alert(data && data.error ? data.error : "예약 생성 실패");
          return;
        }

        this.setState({
          basic_dialog_show_state: true,
          basic_dialog_content: "게시물 예약이 완료되었습니다."
        });
        this.loadInstagramMediaDetail(data.reservation_id, true);

      } else if (publishOption === "NOW") {
        this.setState({
          save_dialog_show_state: true,
          save_dialog_content: "게시물 공유 중입니다."
        });

        const { data } = await http.post("/rest/shop/instagram/media/publish-now", payload);

        this.setState({ save_dialog_show_state: false });

        if (!data || data.ok !== true) {
          alert(data && data.error ? data.error : "게시물 공유 실패");
          return;
        }

        this.setState({
          basic_dialog_show_state: true,
          basic_dialog_content: "게시물 공유가 완료되었습니다.",
          basic_dialog_button_list: [{
            title: "확인",
            event_method: () => {
              window.location.href = "/shop/instagram/InstagramPostList";
            }
          }]
        });
      }
    } catch (err) {
      this.setState({ save_dialog_show_state: false });
      console.error(err);
      alert(err.message || "발행 중 오류 발생");
    }
  };

  draftPost = async () => {
    try {
      const validateMessage = this.validateForDraft();
      if (validateMessage) {
        this.setState({
          warning_dialog_show_state: true,
          warning_dialog_content: validateMessage
        });
        return;
      }

      const { imageSlots, is_draft, ...rest } = this.state;
      const filled = (imageSlots || []).filter((s) => s && (s.media_source_id || s.data));

      if (filled.length === 0) {
        this.setState({
          confirm_dialog_show_state: true,
          confirm_dialog_content: "이미지 없이 임시 저장할까요?",
          confirm_dialog_button_list: [
            {
              title: "네",
              type: "1",
              event_method: () => {
                this.setState({ confirm_dialog_show_state: false });
                this.handleConfirmDraftSave(rest, filled);
              }
            },
            {
              title: "아니요",
              type: "2",
              event_method: () => {
                this.setState({ confirm_dialog_show_state: false });
              }
            }
          ]
        });
        return;
      }

      if (this.state.is_draft === "N") {
        this.setState({
          confirm_dialog_show_state: true,
          confirm_dialog_content: "게시물을 임시저장 상태로 되돌리시겠습니까?<br/>발행은 중단되고, 수정만 가능한 상태가 됩니다.",
          confirm_dialog_button_list: [
            {
              title: "네",
              type: "1",
              event_method: () => {
                this.setState({ confirm_dialog_show_state: false });
                this.handleConfirmDraftSave(rest, filled);
              }
            },
            {
              title: "아니요",
              type: "2",
              event_method: () => {
                this.setState({ confirm_dialog_show_state: false });
              }
            }
          ]
        });
        return;
      }

      this.handleConfirmDraftSave(rest, filled);
    } catch (err) {
      console.error(err);
      alert(err.message || "임시 저장 중 오류 발생");
    }
  };

  handleConfirmDraftSave = async (state, filled) => {
    try {
        this.setState({ save_dialog_show_state: true, save_dialog_content: "임시 저장 중입니다." });
        const { publishOption, selected_ig_access_seq, default_ig_access_seq, caption, tags, scheduledDate, scheduledTime, gpt_caption_seq, gpt_hashtag_seq, aiRecommendations, selectedLabel, selectedFeedType, media_id } = state;

        const items = filled.map((s, idx) => ({
            item_index: idx, is_cover_yn: idx === 0 ? "Y" : "N",
            ...(s.media_source_id ? { media_source_id: s.media_source_id } : { source_type_cd: (s.type === "upload" && "U") || (s.type === "product" && "P") || (s.type === "ai" && "A") || (s.type === "template" && "T") || "U", source_url: s.data }),
            event_seq: s.event_seq || null, product_no: s.product_no || null, stability_call_seq: s.stability_call_seq || null, preview_image_url: s.preview_image_url || null,
        }));

        const now = new Date();
        const defaultDate = now.toISOString().split("T")[0];
        const defaultTime = now.toTimeString().split(" ")[0].slice(0, 5);

        const payload = {
            instagram_access_token_seq: this.getPublishAccountSeq() || null,
            caption: caption || null, hashtags: tags || [],
            scheduled_at: `${scheduledDate || defaultDate}T${scheduledTime || defaultTime}`,
            post_type: publishOption,
            media_type_cd: selectedFeedType === "CAROUSEL" ? "C" : selectedFeedType === "REELS" ? "R" : "S",
            items, gpt_caption_seq: gpt_caption_seq || null, gpt_hashtag_seq: gpt_hashtag_seq || null,
            gpt_caption_suggestions: aiRecommendations ? JSON.stringify(aiRecommendations) : "[]",
            gpt_caption_selected_suggestions: selectedLabel || "",
            image_ratio: this.state.currentRatio || "1/1",
            copywriter_preset_seq: this.state.copywriter_preset_seq || null,
        };

        const url = media_id ? `/rest/shop/instagram/media/drafts/${media_id}` : `/rest/shop/instagram/media/drafts`;
        const { data } = media_id ? await http.put(url, payload) : await http.post(url, payload);

        this.setState({ save_dialog_show_state: false });
        if (!data || data.ok !== true) { alert("임시 저장에 실패하였습니다."); return; }

        this.setState({ basic_dialog_show_state: true, basic_dialog_content: "임시 저장이 완료되었습니다.", media_id: data.media_id, lastDraftId: data.media_id });
        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set("media_id", data.media_id);
        window.history.replaceState({}, "", newUrl);
        this.loadInstagramMediaDetail(data.media_id, true);
    } catch (err) {
        console.error(err);
        this.setState({ save_dialog_show_state: false });
        alert("임시 저장 중 오류 발생");
    }
  };

  getFilledIndices = () => {
    return (this.state.imageSlots || [])
      .map((s, idx) => (this.isFilledSlot(s) ? idx : null))
      .filter((v) => v !== null);
  };

  moveImage = (i, direction) => {
    const filled = this.getFilledIndices();
    const pos = filled.indexOf(i);
    if (pos < 0) return;

    const targetPos = pos + direction;
    if (targetPos < 0 || targetPos >= filled.length) return;

    const j = filled[targetPos];

    this.updateImageSlotsState((imageSlots) => {
      const temp = imageSlots[i];
      imageSlots[i] = imageSlots[j];
      imageSlots[j] = temp;
      return imageSlots;
    });
  };

  renderImageSlots() {
    const { imageSlots } = this.state;
    const BASE_HEIGHT = 100;

    const getRatioValue = (ratioStr) => {
      switch (ratioStr) {
        case "16/9":
          return 16 / 9;
        case "4/5":
          return 4 / 5;
        default:
          return 1;
      }
    };

    const currentRatioValue = getRatioValue(this.state.currentRatio);
    const minWidth = BASE_HEIGHT * currentRatioValue;
    const finalMinWidth = Math.max(minWidth, 100);

    return (
      <>
        <div
          className="slot-container"
          style={{
            display: "grid",
            gridTemplateColumns: `repeat(auto-fill, minmax(${finalMinWidth}px, 1fr))`,
            gap: 12,
            maxWidth: "100%"
          }}
        >
          {imageSlots.map((slot, i) => {
            const filled = this.isFilledSlot(slot);

            const bg = filled
              ? {
                  backgroundImage: `url(${slot.data})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center"
                }
              : { background: "#f3f4f6" };

            return (
              <div
                key={i}
                className={`
                  image-slot
                  ${i === 0 ? "primary" : ""}
                  ${filled ? "filled" : "slot-add has-tooltip"}
                `}
                onClick={() => this.openImageModal(i, slot.type)}
                style={{
                  aspectRatio: this.state.currentRatio ? this.state.currentRatio : "1 / 1",
                  border: filled ? "2px solid #00e2e6" : "2px dashed #cbd5e1",
                  borderRadius: 12,
                  display: "flex",
                  alignItems: filled ? "flex-start" : "center",
                  justifyContent: filled ? "right" : "center",
                  position: "relative",
                  minWidth: 100,
                  padding: "5px 5px",
                  cursor: "pointer",
                  transition: "0.2s",
                  ...bg
                }}
              >
                {filled ? (
                  <>
                    <span
                      className="slot-number"
                      style={{
                        position: "absolute",
                        top: 8,
                        left: 8,
                        background: "rgba(10,26,47,0.7)",
                        color: "#fff",
                        width: 20,
                        height: 20,
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 11
                      }}
                    >
                      {i + 1}
                    </span>

                    <div className="order-controls" onClick={(e) => e.stopPropagation()}>
                      {(() => {
                        const filledIdx = this.getFilledIndices();
                        const pos = filledIdx.indexOf(i);
                        const isFirst = pos === 0;
                        const isLast = pos === filledIdx.length - 1;

                        return (
                          <>
                            <button
                              className="order-btn up"
                              disabled={isFirst}
                              onClick={() => this.moveImage(i, -1)}
                              style={{
                                width: 24,
                                height: 24,
                                borderRadius: "50%",
                                background: "rgba(255,255,255,0.95)",
                                border: "1px solid #00e2e6",
                                color: "#00e2e6",
                                cursor: isFirst ? "not-allowed" : "pointer",
                                fontWeight: 700
                              }}
                            >
                              ▲
                            </button>
                            <button
                              className="order-btn down"
                              disabled={isLast}
                              onClick={() => this.moveImage(i, +1)}
                              style={{
                                width: 24,
                                height: 24,
                                borderRadius: "50%",
                                background: "rgba(255,255,255,0.95)",
                                border: "1px solid #00e2e6",
                                color: "#00e2e6",
                                cursor: isLast ? "not-allowed" : "pointer",
                                fontWeight: 700
                              }}
                            >
                              ▼
                            </button>
                          </>
                        );
                      })()}

                      <button
                        className="delete-btn"
                        onClick={(e) => this.deleteImageAt(e, i)}
                        style={{
                          width: 24,
                          height: 24,
                          borderRadius: "50%",
                          background: "rgba(255,255,255,0.9)",
                          border: "1px solid #dc2626",
                          color: "#dc2626",
                          cursor: "pointer",
                          fontSize: 18,
                          lineHeight: 1
                        }}
                      >
                        ×
                      </button>
                    </div>

                    <span
                      className="image-source-badge"
                      style={{
                        position: "absolute",
                        left: 8,
                        bottom: 8,
                        width: "fit-content",
                        color: "#fff",
                        fontWeight: 700,
                        textShadow: "0 1px 2px rgba(0,0,0,.35)",
                        fontSize: 12,
                        background: "rgba(10, 26, 47, 0.7)",
                      }}
                    >
                      {slot.type === "upload"
                        ? "업로드"
                        : slot.type === "product"
                        ? "상품"
                        : slot.type === "ai"
                        ? "AI"
                        : slot.type === "template"
                        ? "템플릿"
                        : ""}
                    </span>
                  </>
                 ) : (
                  <>
                    <div style={{ textAlign: "center", width: "100%" }}>
                      <div style={{ fontSize: "28px", color: "#9ca3af" }}>+</div>
                    </div>
                    <div className="tooltip-down">사진 또는 AI디자인도구 등으로 제작</div>
                  </>
                )}
              </div>
            );
          })}
        </div>
        <div style={{ marginTop: 12, fontSize: 12, color: "#6b7280" }}>
          이미지를 추가하면 다음 칸이 생성되며, 최대 10개까지 등록 가능합니다.
        </div>
      </>
    );
  }

  getFilledImages = () => {
    return (this.state.imageSlots || [])
      .filter((s) => this.isFilledSlot(s))
      .map((s) => s.data);
  };

  setSlide = (idx) => {
    const imgs = this.getFilledImages();
    if (!imgs.length) return;
    const next = ((idx % imgs.length) + imgs.length) % imgs.length;
    this.setState({ previewSlideIndex: next });
  };
  nextSlide = () => { const { previewSlideIndex = 0 } = this.state; this.setSlide(previewSlideIndex + 1); };
  previousSlide = () => { const { previewSlideIndex = 0 } = this.state; this.setSlide(previewSlideIndex - 1); };

  applyAIImg(img, stability_call_seq){
    this.updateImageSlotsState((imageSlots) => {
      imageSlots[this.state.currentImageSlotIndex] = {
        type: "ai",
        data: img,
        stability_call_seq: stability_call_seq
      };
      return imageSlots;
    });
  }

  onClickAddProductbtn(selected_product_list){
     this.setState({ show_add_product_popup:false, save_dialog_show_state: true });
     this.setState({
      save_dialog_show_state: true,
      save_dialog_content: "이미지를 적용 중입니다."
    });
     const config = { headers: { 'Content-Type': 'application/json' } }
     const body = { image_url: selected_product_list[0].image_url, ratio: this.state.currentRatio ? this.state.currentRatio : "1/1" }
     http.post("/rest/shop/instagram/resizeUrlImg", body, config)
     .then(res => {
        const url = res.data.org_img_path;
        this.setSelectedProduct(selected_product_list, url);
        this.setState({ save_dialog_show_state: false, save_dialog_show_state: false });
      }).catch(error => { console.log (error); this.setState({ save_dialog_show_state: false }); })
  }

  setSelectedProduct(selected_product_list, img_url) {
    this.updateImageSlotsState((imageSlots) => {
      imageSlots[this.state.currentImageSlotIndex] = {
        type: "product",
        data: img_url,
        product_no: selected_product_list[0].product_no,
        product_name: selected_product_list[0].product_name,
        product_price: selected_product_list[0].product_price,
        image_url: selected_product_list[0].image_url
      };
      return imageSlots;
    });

    this.setState({
      selected_rp_product_list: selected_product_list
    });
  }
  applydDesign(event_seq, img_url) {
    this.updateImageSlotsState((imageSlots) => {
      imageSlots[this.state.currentImageSlotIndex] = {
        type: "template",
        data: img_url,
        event_seq: event_seq,
        image_url: img_url
      };
      return imageSlots;
    });

    this.setState({
      show_design_template_popup: false
    });
  }

  setCaption = (nextCaption, callback) => {
    this.setState(prev => ({ caption_history: [...prev.caption_history, prev.caption], caption: nextCaption, caption_future: [] }), () => { if (callback) callback(); });
  };

  undoCaption = () => {
    this.setState(prev => {
      if (prev.caption_history.length === 0) return null;
      const prevCaption = prev.caption_history[prev.caption_history.length - 1];
      const caption_history = prev.caption_history.slice(0, -1);
      return { caption: prevCaption, caption_history, caption_future: [prev.caption, ...prev.caption_future] };
    });
  };
  
  redoCaption = () => {
    this.setState(prev => {
      if (prev.caption_future.length === 0) return null;
      const nextCaption = prev.caption_future[0];
      const caption_future = prev.caption_future.slice(1);
      return { caption: nextCaption, caption_history: [...prev.caption_history, prev.caption], caption_future };
    });
  };

  handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;
    this.setState((prev) => {
      const { tags } = prev;
      const oldIndex = tags.indexOf(active.id);
      const newIndex = tags.indexOf(over.id);
      if (oldIndex === -1 || newIndex === -1) return null;
      return { tags: arraymMoveByDndKit(tags, oldIndex, newIndex) };
    });
  };

  instagramFreePreriod() {
    http.get("/rest/shop/instagram/FreePreriod").then(res => {
        if (res.data.is_finish != null) {
            this.setState({ instagram_is_finish: res.data.is_finish });
            if (res.data.is_finish == 1) {
              alert("이용 기간이 종료되었습니다.");
              window.location.href = "/shop/instagram/InstagramPostList";
            }
        }
    }).catch(error => { console.error(error); })
  }

  updateSelectedAccountsUseYn = () => {
    const { token_id, selected_account_list } = this.state;
    if (!selected_account_list || selected_account_list.length === 0) {
      this.setState({ warning_dialog_show_state: true, warning_dialog_content: "하나 이상의 계정을 선택 해 주세요." });
      return;
    }
    http.post("/rest/shop/instagram/updateAccountsUseYn", { token_id, selected_account_list, use_yn: "Y" }, { headers: { "Content-Type": "application/json" } })
      .then((res) => {
        const data = res && res.data ? res.data : {};
        if (String(data.code) === "200") {
          this.loadInstagramAccountList();
          this.setState({ show_account_connect_popup: false });
        } else {
          this.setState({ warning_dialog_show_state: true, warning_dialog_content: "계정 업데이트에 실패했습니다." });
        }
      })
      .catch((err) => {
        this.setState({ warning_dialog_show_state: true, warning_dialog_content: "서버 요청 중 오류가 발생했습니다." });
      });
  };

  handleConnectAccount = () => {
    const authUrl = `https://www.facebook.com/v24.0/dialog/oauth?client_id=${FACEBOOK_APP_ID}&redirect_uri=${encodeURIComponent(REDIRECT_URI)}&scope=${SCOPES}&response_type=code`;
    window.open(authUrl);
  };

  handleClickOutside = (event) => {
    // 피커 외부 클릭이면서, 동시에 버튼도 클릭하지 않았을 때만 닫기
    if (
      this.pickerRef.current && 
      !this.pickerRef.current.contains(event.target) &&
      this.triggerRef.current && 
      !this.triggerRef.current.contains(event.target) // 버튼 클릭은 무시
    ) {
      this.setState({ emojiPickerVisible: false });
    }
  }

  // // 태그 추가 공통 로직
  // addTag = (newTagValue) => {
  //     const newTag = newTagValue.trim();
  //     if (!newTag) return;

  //     // '#' 기호가 없으면 자동으로 붙여줌
  //     const formattedTag = newTag.startsWith('#') ? newTag : `#${newTag}`;

  //     // 최대 30개 제한 방어
  //     if (this.state.tags.length >= 30) {
  //         alert("해시태그는 최대 30개까지만 등록 가능합니다.");
  //         return;
  //     }

  //     // 중복 체크 후 추가
  //     if (!this.state.tags.includes(formattedTag)) {
  //         this.setState(prevState => ({
  //             tags: [...prevState.tags, formattedTag],
  //             tagInput: "" // 입력창 비우기
  //         }));
  //     } else {
  //         this.setState({ tagInput: "" }); // 이미 있으면 창만 비움
  //     }
  // }

  // // Input 키보드 이벤트
  // handleTagKeyDown = (e) => {
  //     if (e.key === 'Enter' || e.key === ' ' || e.code === 'Space') {
  //         e.preventDefault();
  //         this.addTag(this.state.tagInput);
  //     } 
  //     // 입력창이 비어있을 때 백스페이스 누르면 마지막 칩 삭제
  //     else if (e.key === 'Backspace' && !this.state.tagInput && this.state.tags.length > 0) {
  //         this.setState(prevState => ({
  //             tags: prevState.tags.slice(0, -1)
  //         }));
  //     }
  // };

  handleComposition = (e) => {
    if (e.type === 'compositionstart') this.isComposing = true;
    if (e.type === 'compositionend') this.isComposing = false;
  };

  handleTagKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === " ") {
      e.preventDefault();
      this.addTag(e.target.value);
    }
  };

  addTag = (valueRaw) => {
    if (this.isComposing) return; // 조합 중이면 무시
    
    // 1. # 기준으로 문자열을 나누고, 공백 제거 및 빈 값 필터링
    const rawParts = valueRaw.split('#').map(t => t.trim()).filter(t => t);
    
    if (rawParts.length === 0) return;

    // 2. 각 태그에 # 붙이기 및 Sanitization
    const newTags = rawParts.map(t => `#${this.sanitizeHashtag(t)}`);

    this.setState((prev) => {
      // 3. 기존 태그와 합치고 중복 제거 (Set 사용)
      const combinedTags = [...new Set([...prev.tags, ...newTags])];

      // 4. 30개 제한 체크
      if (combinedTags.length > 30) {
        alert("해시태그는 최대 30개까지만 등록 가능합니다.");
        // 30개까지만 잘라서 반영
        // return { tags: combinedTags.slice(0, 30), inputHashtagValue: "" };
        return { tags: combinedTags, inputHashtagValue: "" };
      }

      return { tags: combinedTags, inputHashtagValue: "" };
    });
  }

  openConfirmDialog(props) {
    return new Promise((resolve) => {
      const container = document.createElement("div");
      document.body.appendChild(container);

      const close = (result) => {
        resolve(result);
        ReactDOM.unmountComponentAtNode(container);
        container.remove();
      };

      ReactDOM.render(
        <TitleContentDialogV2
          {...props}
          popup_close={() => close(false)}
          button_list={[
            {
              title: "확인",
              event_method: () => close(true),
            },
            {
              title: "취소",
              event_method: () => close(false),
            },
          ]}
        />,
        container
      );
    });
  }

  loadNewFixedTagList = () => {
    http.get("/rest/shop/favorite-hashtags")
    .then(res => {
        // res.data는 서버에서 보낸 응답 객체입니다.
        if (res.data.status === 'success' && res.data.list != null) {
            this.setState({ fixedTags: res.data.list });
        } else {
            console.error("데이터 조회 실패:", res.data.message);
        }
    })
    .catch(error => {
        console.error("통신 에러:", error);
    });
  }

  async addFavoriteHashtag(hashtagValue) {
    // 1. 임시 고유 ID 생성
    const tempId = 'temp_' + Date.now();

    // 2. [Optimistic Update] 일단 UI에 즉시 추가
    this.setState(prev => ({
      fixedTags: [...prev.fixedTags, { favorite_tag_seq: tempId, tag_name: hashtagValue }],
      newFixedTagInput: ""
    }));

    try {
      const res = await http.post("/rest/shop/favorite-hashtags", {
        tag_name: hashtagValue,
        sort_order: 1
      });

      if (res.data.status === 'success') {
        // 3. [성공 시] 서버에서 받은 진짜 ID로 교체
        const realId = res.data.favorite_tag_seq;
        this.setState(prev => ({
          fixedTags: prev.fixedTags.map(tag =>
            tag.favorite_tag_seq === tempId ? { ...tag, favorite_tag_seq: realId } : tag
          )
        }));
      } else {
        // 4. [논리적 실패 시] 에러 발생 (catch 블록으로 이동)
        throw new Error(res.data.message);
      }
    } catch (error) {
      console.error("통신 에러:", error);
      alert("등록 실패: " + (error.message || "서버 오류 발생"));

      // 5. [복구(Rollback)] 실패 시 추가했던 임시 태그 삭제
      this.setState(prev => ({
        fixedTags: prev.fixedTags.filter(tag => tag.favorite_tag_seq !== tempId)
      }));
    }
  }
  
  updateFavoriteHashtag() {
    // API 호출
    http.post("/rest/shop/favorite-hashtags/sort-order", {
        list: this.state.fixedTags
    })
    .then(res => {
        if (res.data.status === 'success') {
            console.log("순서 변경 완료!");
        }
    })
    .catch(error => {
        console.error("통신 실패:", error);
    });
  }

  // [데이터 로드]
  loadQuickPhrases = () => {
      http.get("/rest/shop/favorite-phrases")
      .then(res => {
          if (res.data.status === 'success') {
            const mappedPhrases = res.data.list.map(item => ({
              favorite_phrase_seq: item.favorite_phrase_seq,
              title: item.phrase_title,     // DB의 phrase_title을 title로
              content: item.phrase_content  // DB의 phrase_content를 content로
            }));

            this.setState({ quickPhrases: mappedPhrases });
          }
      });
  }

  // [추가 API]
  addNewPhraseByAPI = async () => {
      const { phraseTitleInput, phraseContentInput } = this.state;
      const tempId = 'temp_' + Date.now();

      // Optimistic Update
      this.setState(prev => ({
          quickPhrases: [...prev.quickPhrases, { favorite_phrase_seq: tempId, title: phraseTitleInput, content: phraseContentInput }],
          phraseTitleInput: "",
          phraseContentInput: "",
          modals: { ...this.state.modals, phrase: false }
      }));

      try {
          const res = await http.post("/rest/shop/favorite-phrases", {
              phrase_title: phraseTitleInput,
              phrase_content: phraseContentInput
          });

          if (res.data.status === 'success') {
              // 서버 ID로 교체
              this.setState(prev => ({
                  quickPhrases: prev.quickPhrases.map(p => 
                      p.favorite_phrase_seq === tempId ? { ...p, favorite_phrase_seq: res.data.favorite_phrase_seq } : p
                  )
              }));
          }
      } catch (e) {
          alert("저장 실패");
          this.setState(prev => ({ quickPhrases: prev.quickPhrases.filter(p => p.favorite_phrase_seq !== tempId) }));
      }
  }

  /* 피드문구, 해시태그 개수 설정 조회  */
  loadGenerationCount = () => {
    // this.setState({ 
    //   save_dialog_show_state: true,
    //   save_dialog_content: "로딩중 입니다.",
    //   save_dialog_button_list: [{ title: "확인", type: "1", display_yn:"N" }],
    // });

    http.get('/rest/shop/instagram/generation-count')
    .then(response => {
      // if (response && response.data) {
        const data = response.data.result || {};
        this.setState({
          hashtag_setting_count: data.manual_hashtag_count || 5,
          caption_setting_count: data.manual_caption_count || 3,
          is_auto_hashtag_on: data.manual_is_auto_hashtag_on !== undefined ? data.manual_is_auto_hashtag_on : false,
          
          // save_dialog_show_state: false,
        });
      // }
    })
    .catch(error => {
      console.error("데이터 조회 에러:", error);
      // this.setState({ save_dialog_show_state: false });
    });
  };

  isValidIgSeq = (value) => {
    if (value === null || value === undefined) return false;

    const v = String(value).trim();

    if (!v) return false;
    if (v === "none" || v === "add") return false;

    return true;
  };

  getPublishAccountSeq = () => {
    const { selected_ig_access_seq, default_ig_access_seq } = this.state;

    if (this.isValidIgSeq(selected_ig_access_seq)) {
      return String(selected_ig_access_seq).trim();
    }

    if (this.isValidIgSeq(default_ig_access_seq)) {
      return String(default_ig_access_seq).trim();
    }

    return "";
  };

  // =========================================================
  //  [RENDER] 고도화된 UI 렌더링 시작
  // =========================================================
  render() {
    const { 
        publishOption, caption, selectedAccount, aiSuggestionsVisible, tags, topicInput,
        scheduledDate, scheduledTime, account_list_v2, default_ig_access_seq,
        selected_ig_access_seq, aiRecommendations, selectedLabel, activeSection,
        quickPhrases, manualTags, fixedTags, modals, accountConnected, hashtag_setting_count, caption_setting_count, is_auto_hashtag_on
    } = this.state;
  
    const previewAccount = selectedAccount || {title: "계정 미연동", profile_picture_url: null};
    
    const imgs = this.getFilledImages();
    const hasSlides = imgs.length > 1;
    const currentIdx = imgs.length ? ((this.state.previewSlideIndex % imgs.length) + imgs.length) % imgs.length : 0;
    const currentImg = imgs.length > 0 ? imgs[currentIdx] : null;

    // --- 계정 리스트 동적 생성 로직 ---
    let displayAccountList = [];
    let selectedAccountText = null;
    if (!accountConnected || !account_list_v2 || account_list_v2.length === 0) {
        // 계정 연동이 안 된 상태일 때
        displayAccountList = [
            { title: "+ 인스타그램 연동하기", value: "add" }
        ];

        selectedAccountText = "계정 미연동";
    } else {
        // 계정 연동이 된 상태일 때 (계종명 앞에 @ 붙이기)
        displayAccountList = _.cloneDeep(account_list_v2 || []);
        displayAccountList = account_list_v2.map(acc => {
            return {
                ...acc, // 기존 속성(value, profile_picture_url 등)은 그대로 복사
                // 방어 로직: 혹시 이미 @가 붙어있다면 그대로 두고, 없다면 붙임
                title: acc.title.startsWith('@') ? acc.title : '@' + acc.title 
            };
        });
    }

    // 1. [개수 계산용] 배열의 길이가 곧 태그의 개수 (정규식 필요 없음!)
    const tagCount = tags.length;

    // 2. [글자 수 계산용] 배열을 띄어쓰기 한 칸으로 예쁘게 연결
    const hashtagText = tags.join(" "); 

    // 3. 해시태그 총 길이 (본문과 태그 사이 줄바꿈/띄어쓰기 1자 포함)
    const hashtagLength = hashtagText.length > 0 ? hashtagText.length + 1 : 0; 

    // 4. 본문 최대 입력 가능 길이 계산 (2,200자 - 해시태그 길이)
    const maxCaptionLength = Math.max(0, 2200 - hashtagLength);
  
    return (
      <>
      <div className="instagram_post_page">
        <div className="main-wrapper" id="page-wrapper" style={{ paddingTop: '72px', maxWidth: '100%', height: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#f3f4f6', fontFamily: "'Noto Sans KR', sans-serif" }}>
          {/* --- [STYLE] HTML에서 가져온 전체 CSS --- */}
          <style>{`
              .instagram_post_page {
                  --primary-mint: #00e2e6;
                  --primary-mint-hover: #00bfc2;
                  --deep-navy: #0A1A2F;
                  --deep-navy-hover: #111C3A;
                  --bg-color: #f3f4f6; 
                  --border-color: #e5e7eb;
                  --text-main: #0A1A2F;
                  --text-sub: #6b7280;
                  --white: #ffffff;
                  --radius-md: 12px;
                  --radius-sm: 8px;
              }
              .instagram_post_page .main-wrapper * { box-sizing: border-box; font-size: 14px; }
              .instagram_post_page .main-wrapper textarea { font-family: 'Noto Sans KR', sans-serif; font-size: 14px !important;}
              .instagram_post_page .main-wrapper input { font-family: 'Noto Sans KR', sans-serif; font-size: 14px;}
              .instagram_post_page .main-wrapper input::placeholder { font-family: 'Noto Sans KR', sans-serif; font-size: 14px;}
              .instagram_post_page .main-wrapper textarea::placeholder { font-family: 'Noto Sans KR', sans-serif; font-size: 14px;}
              .instagram_post_page .main-wrapper button { box-shadow: 0 0 0 0px transparent !important; }
              
              .instagram_post_page .main-wrapper .react-datepicker-wrapper { margin-bottom: 0; }

              .instagram_post_page #page-wrapper { max-width: 100% !important; }
              @media (min-width: 801px) {
                  body:has(.instagram_post_page) { overflow: hidden !important; }
                  .instagram_post_page#page-wrapper { padding-top: 72px !important; }
                  .instagram_post_page .header-row { 
                    width: 100% !important; 
                    box-sizing: border-box !important; /* 100%가 패딩 안쪽 기준이 되도록 설정 */
                    position: relative !important;     /* 혹시 외부 CSS에서 fixed로 띄운 걸 강제로 주저앉힘 */
                    margin-top: 0 !important; 
                    margin-left: 0 !important; 
                    margin-right: 0 !important;
                    min-width: 1010px;
                  }
                  .instagram_post_page .main-container { margin-top: 0px !important; min-width: 1010px; }
              }
              .instagram_post_page {
                /* Tooltips */
                .nav-tooltip { position: absolute; left: 100%; margin-left: 14px; background: var(--deep-navy); color: white; padding: 6px 12px; border-radius: 6px; font-size: 12px; font-weight: 600; white-space: nowrap; pointer-events: none; opacity: 0; transform: translateX(-10px); transition: all 0.2s; z-index: 200; box-shadow: 0 4px 12px rgba(10,26,47,0.15); }
                .nav-tooltip::before { content: ''; position: absolute; right: 100%; top: 50%; transform: translateY(-50%); border-width: 5px; border-style: solid; border-color: transparent var(--deep-navy) transparent transparent; }
                .nav-item:hover .nav-tooltip { opacity: 1; transform: translateX(0); }

                .has-tooltip { position: relative; display: inline-flex; align-items: center; justify-content: center; }
                .tooltip-down { position: absolute; top: 100%; left: 50%; transform: translateX(-50%) translateY(10px); background: var(--deep-navy); color: white; padding: 6px 12px; margin-top: 6px; border-radius: 6px; font-size: 12px; font-weight: 600; white-space: nowrap; pointer-events: none; opacity: 0; visibility: hidden; transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1); z-index: 2000; box-shadow: 0 4px 12px rgba(10,26,47,0.15); }
                .tooltip-down::before { content: ''; position: absolute; bottom: 100%; left: 50%; transform: translateX(-50%); border-width: 5px; border-style: solid; border-color: transparent transparent var(--deep-navy) transparent; }
                .has-tooltip:hover .tooltip-down { opacity: 1; visibility: visible; transform: translateX(-50%) translateY(0); }

                .tooltip-up { position: absolute; bottom: 100%; left: 50%; transform: translateX(-50%) translateY(-10px); background: var(--deep-navy); color: white; padding: 6px 12px; margin-bottom: 6px; border-radius: 6px; font-size: 12px; font-weight: 600; white-space: nowrap; pointer-events: none; opacity: 0; visibility: hidden; transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1); z-index: 2000; box-shadow: 0 4px 12px rgba(10,26,47,0.15); }
                .tooltip-up::before { content: ''; position: absolute; top: 100%; left: 50%; transform: translateX(-50%); border-width: 5px; border-style: solid; border-color: var(--deep-navy) transparent transparent transparent; }
                .has-tooltip:hover .tooltip-up { opacity: 1; visibility: visible; transform: translateX(-50%) translateY(0); }
                
                /* Header */
                .header-row { flex-shrink: 0; display: flex; align-items: center; justify-content: space-between; background: var(--white); padding: 16px 24px; border-bottom: 1px solid var(--border-color); z-index: 1000; box-shadow: 0 4px 12px rgba(10, 26, 47, 0.04); margin-top: 72px; flex-wrap: wrap; gap: 16px; }
                .page-title { font-size: 20px; font-weight: 800; display: flex; align-items: center; gap: 10px; color: var(--deep-navy); }
                .page-title::before { content: ''; width: 6px; height: 20px; background: var(--primary-mint); border-radius: 3px; display: block; }
                .header-actions { display: flex; align-items: center; gap: 12px; }

                .slot-add:hover {
                    border-color: var(--primary-mint) !important;
                    color: var(--primary-mint) !important;
                    background: #f0fdfe !important;
                }
                
                /* UI Components */
                .segmented-control { display: flex; background: var(--bg-color); padding: 4px; border-radius: var(--radius-sm); border: 1px solid var(--border-color); }
                .segment-btn { display: flex; gap: 5px; align-items: center; padding: 8px 16px; border-radius: 6px; font-size: 13px; font-weight: 700; color: var(--text-sub); cursor: pointer; border: none; background: transparent; transition: all 0.2s; white-space: nowrap; flex: 1; text-align: center; }
                .segment-btn.active { background: var(--white); color: var(--deep-navy); box-shadow: 0 1px 3px rgba(0,0,0,0.1); }
                
                .btn { height: 42px; padding: 0 20px; border-radius: var(--radius-sm); font-size: 14px; font-weight: 700; cursor: pointer; border: none; transition: 0.2s; display: inline-flex; align-items: center; justify-content: center; gap: 6px; white-space: nowrap; }
                .btn-primary { background: var(--primary-mint); color: var(--deep-navy); box-shadow: 0 2px 8px rgba(0, 226, 230, 0.2); }
                .btn-primary:hover { background: var(--primary-mint-hover); color: var(--deep-navy); transform: translateY(-1px); box-shadow: 0 4px 12px rgba(0, 226, 230, 0.3); }
                .btn-primary:active { background: var(--primary-mint-hover) !important; color: var(--deep-navy) !important; transform: translateY(-1px) !important; box-shadow: 0 4px 12px rgba(0, 226, 230, 0.3) !important; }
                .btn-primary:focus { background: var(--primary-mint-hover) !important; color: var(--deep-navy) !important; transform: translateY(-1px) !important; box-shadow: 0 4px 12px rgba(0, 226, 230, 0.3) !important; }
                .btn-black { background: #111827; color: #ffffff; }
                .btn-black:hover { background: #000000; transform: translateY(-1px); box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); color: #ffffff; }
                .btn-purple { background: #f5f3ff; border: 1px solid #ddd6fe; color: #6d28d9; }
                .btn-purple:hover { background: #ede9fe; border-color: #c4b5fd; color: #581c87; }
                .icon-btn-purple { background: #f5f3ff; border: 1px solid #ddd6fe; cursor: pointer; font-size: 14px; margin-left: 6px; padding: 4px 8px; border-radius: 6px; transition: 0.2s; color: #6d28d9; vertical-align: middle; }
                .icon-btn-purple:hover { background: #ede9fe; border-color: #c4b5fd; color: #581c87; }
                .btn-outline { background: var(--white); border: 1px solid #d1d5db; color: #4b5563; }
                .btn-outline:hover { background: var(--bg-color); border-color: var(--primary-mint); color: var(--deep-navy); }
                .btn-apply { height: 34px; padding: 0 16px; border-radius: 6px; font-size: 13px; font-weight: 700; background: var(--white); border: 1px solid #cbd5e1; color: #475569; transition: 0.2s; }
                .ai-card:hover .btn-apply { border-color: var(--primary-mint); color: #0d9488; background: #f0fdfe; }
                
                /* Main Layout */
                .main-container { flex: 1; display: grid; grid-template-columns: 80px 1fr 420px; height: 100%; overflow: hidden; margin-top: 90px; 
                  /* max-width: 1600px; */
                  width: 100%; 
                }
                
                .side-nav-area { background: var(--white); border-right: 1px solid var(--border-color); padding: 24px 0; display: flex; flex-direction: column; gap: 16px; align-items: center; z-index: 10; box-shadow: 2px 0 8px rgba(10, 26, 47, 0.02); }
                .nav-item { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 6px; width: 64px; height: 64px; border-radius: 12px; cursor: pointer; color: #9ca3af; transition: 0.2s; position: relative; }
                .nav-item:hover { background: var(--bg-color); color: var(--deep-navy); }
                .nav-item.active { background: #f0fdfe; color: #0d9488; font-weight: 700; box-shadow: 0 2px 6px rgba(0,226,230,0.15); }
                .nav-icon { font-size: 20px; }
                .nav-label { font-size: 11px; }

                .input-scroll-area { padding: 24px 32px 60px 24px; overflow-y: auto; display: flex; flex-direction: column; gap: 32px; scroll-behavior: smooth; }
                .input-scroll-area::-webkit-scrollbar { width: 10px; }
                .input-scroll-area::-webkit-scrollbar-track { background: transparent; }
                .input-scroll-area::-webkit-scrollbar-thumb { background-color: #cbd5e1; border-radius: 10px; border: 2px solid var(--bg-color); }
                .input-scroll-area::-webkit-scrollbar-thumb:hover { background-color: #9ca3af; }

                .card { background: var(--white); border-radius: var(--radius-md); border: 1px solid var(--border-color); padding: 28px; box-shadow: 0 2px 8px rgba(10, 26, 47, 0.04); }
                .section-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
                .section-title { font-size: 18px; font-weight: 800; color: var(--deep-navy); display: flex; align-items: center; gap: 4px; }
                
                .status-badge { font-size: 12px; font-weight: 600; color: var(--text-sub); background: var(--bg-color); padding: 6px 12px; border-radius: 6px; display: inline-flex; align-items: center; gap: 6px; border: 1px dashed #cbd5e1; cursor: help; }
                .toolbar { display: flex; gap: 8px; padding: 10px 14px; background: #f8fafc; border: 1px solid #cbd5e1; border-bottom: none; border-radius: 8px 8px 0 0; }
                .tool-btn { background: var(--white); border: 1px solid #d1d5db; border-radius: 4px; padding: 4px 10px; font-size: 13px; cursor: pointer; color: #475569; transition: 0.2s; }
                .tool-btn:hover { background: var(--bg-color); border-color: var(--primary-mint); color: var(--primary-mint-hover); }

                .chip-container { display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 12px; align-items: center; }
                .phrase-chip { padding: 8px 16px; border-radius: 20px; font-size: 13px; font-weight: 600; cursor: pointer; background: var(--bg-color); border: 1px solid transparent; color: #374151; display: flex; align-items: center; gap: 6px; transition: 0.2s; }
                .phrase-chip:hover { background: #e2e8f0; border-color: #cbd5e1; }
                .chip-new { border: 1px dashed #9ca3af; background: transparent; color: #2563eb; }
                .chip-new:hover { border-color: #2563eb; background: #eff6ff; }
                .chip-delete { font-size: 14px; color: #9ca3af; padding-left: 2px; transition: 0.2s; }
                .chip-delete:hover { color: #dc2626; transform: scale(1.2); }

                .ai-section { margin-top: 32px; padding: 24px; background: #f8fafc; border-radius: 12px; border: 1px solid #e2e8f0; }
                .ai-header-row { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; flex-wrap: wrap; gap: 12px; }
                .ai-card { background: var(--white); border: 1px solid var(--border-color); border-radius: 10px; padding: 20px; cursor: pointer; transition: 0.2s; position: relative; box-shadow: 0 2px 4px rgba(10,26,47,0.02); margin-bottom: 16px;}
                .ai-card:hover { border-color: var(--primary-mint); box-shadow: 0 4px 16px rgba(0, 226, 230, 0.12); transform: translateY(-2px); }
                
                /* 일체형 프롬프트 입력창 (Search bar style) */
                .ai-prompt-container {
                    display: flex; align-items: center; background: white;
                    border: 2px solid #e5e7eb; border-radius: var(--radius-md);
                    padding: 4px; box-shadow: 0 2px 8px rgba(10,26,47,0.03);
                    transition: all 0.3s; margin-bottom: 12px;
                }
                .ai-prompt-container:focus-within {
                    border-color: var(--primary-mint); 
                    box-shadow: 0 0 0 4px rgba(0, 226, 230, 0.15);
                }
                .ai-prompt-input {
                    flex: 1; border: none; background: transparent; padding: 14px 16px;
                    font-size: 15px; color: var(--text-main); outline: none; font-family: inherit;
                    border: 0px solid transparent !important;
                }

                /* Preview Area */
                .preview-fixed-area { padding: 24px; background: var(--white); border-left: 1px solid var(--border-color); overflow-y: auto; box-shadow: -2px 0 8px rgba(10, 26, 47, 0.02); z-index: 10; }
                .insta-frame { background: var(--white); border: 1px solid #dbdbdb; border-radius: 8px; width: 100%; max-width: 360px; margin: 0 auto; box-shadow: 0 4px 20px rgba(0,0,0,0.06); word-break: break-word; overflow: hidden; }

                /* Modals */
                .modal-overlay { display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(10,26,47,0.6); z-index: 9999; align-items: center; justify-content: center; 
                    /* -backdrop-filter: blur(2px); */
                }
                .modal-overlay.open { display: flex; animation: fadeIn 0.2s ease; }
                .modal-box { background: var(--white); width: 440px; max-width: 90%; border-radius: 16px; padding: 32px; box-shadow: 0 20px 50px rgba(10,26,47,0.2); animation: slideUp 0.3s ease; }
                .modal-title { font-size: 20px; font-weight: 800; margin-bottom: 20px; color: var(--deep-navy); }
                
                #ig_account_select {
                  // background-color: var(--bg-color);
                  font-weight: 700;
                  color: var(--deep-navy);
                }

                .date-wrapper { width: 130px; display: block; }
                .time-wrapper { width: 110px; display: block; }

                .custom-date-picker, .custom-time-picker {
                    height: 42px !important;
                    padding: 0 12px !important;
                    padding-right: 32px !important; /* 아이콘이 들어갈 우측 여백 */
                    width: 100% !important;
                    font-family: 'Noto Sans KR', sans-serif;
                    font-size: 14px;
                    color: var(--deep-navy);
                    background-repeat: no-repeat;
                    background-position: right 10px center;
                    cursor: pointer;
                    background-color: var(--white);
                    border: 1px solid var(--border-color) !important;
                    border-radius: var(--radius-sm);
                    transition: all 0.2s;
                    box-sizing: border-box;
                }

                /* 클릭(포커스) 되었을 때 테두리 색상 변경 */
                .custom-date-picker:focus, .custom-time-picker:focus {
                    border-color: var(--primary-mint) !important;
                    outline: none;
                    box-shadow: 0 0 0 3px rgba(0, 226, 230, 0.15) !important;
                }

                /* 날짜 입력창 우측 달력 SVG 아이콘 */
                .custom-date-picker {
                    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="%236b7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>');
                }

                /* 시간 입력창 우측 시계 SVG 아이콘 */
                .custom-time-picker {
                    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="%236b7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>');
                }

                #imageSelectModal h4 {
                  font-size: 1.1em !important;
                  font-weight: 700 !important;
                  margin-top: 0 !important;
                }

                .form-control:focus {
                    outline: none;
                    border-color: var(--primary-mint) !important;
                    box-shadow: 0 0 0 3px rgba(0, 226, 230, 0.15);
                }

                /* [Info Banner] */
                .info-banner { background: #f5f3ff; border: 1px solid #ddd6fe; border-radius: var(--radius-md); padding: 16px 24px; display: flex; justify-content: space-between; align-items: center; box-shadow: 0 2px 8px rgba(109, 40, 217, 0.05); gap: 16px; flex-wrap: wrap; }
                .info-banner-text { color: #581c87; font-weight: 600; font-size: 14px; display: flex; align-items: center; gap: 8px; }

                .has-tooltip:has(#select_option_area) .tooltip-down { display: none !important; }

                .modal-overlay open { z-index: 9999 !important; }

                .instagram_post_page .common_text_input input {
                    width: 100%;
                    padding: 12px 16px;
                    border: 2px solid #e5e7eb;
                    border-radius: 8px;
                    font-size: 14px;
                    transition: all 0.2s;
                    background: white;
                    color: #0A1A2F;
                }

                .instagram_post_page .common_text_input input:focus {
                    outline: none;
                    border-color: #00e2e6;
                    box-shadow: 0 0 0 3px rgba(0, 226, 230, 0.1);
                }
                
                .instagram_post_page .common_text_input input:hover {
                    outline: none;
                    border-color: #e5e7eb;
                }

                .order-controls {
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                }

                /* Setting Link */
                .setting-link { display: inline-flex; align-items: center; gap: 4px; font-size: 13px; font-weight: 600; color: var(--text-sub); background: var(--bg-color); padding: 8px 16px; border-radius: 20px; border: 1px solid #cbd5e1; cursor: pointer; transition: 0.2s; text-decoration: none; line-height: 0;}
                .setting-link:hover { border-color: var(--deep-navy); color: var(--deep-navy); background: white; }

                button:focus {
                  box-shadow: none !important;
                }

                .gpt-usage-inline {
                  font-size: 13px;
                  font-weight: 400;
                  color: #6b7280;
                  margin-bottom: 6px;
                  text-align: right;
                  display: flex;
                  flex-wrap: wrap;
                  justify-content: flex-end;
                  align-items: center;
                  gap: 5px;
                }

                @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
                @keyframes slideUp { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }

                @media (max-width: 800px) {
                    #page-wrapper { height: auto !important; padding-top: 60px !important; padding-bottom: 92px !important; padding-left: 0 !important; padding-right: 0 !important; }
                    .main-container { display: flex; flex-direction: column; height: auto; overflow: visible; margin-top: 0; }
                    .side-nav-area { display: none; } 
                    .input-scroll-area { padding: 20px 16px; height: auto; overflow: visible; gap: 20px; }
                    .preview-fixed-area { border-left: none; border-top: 1px solid var(--border-color); padding: 32px 16px; }
                    
                    .header-row { position: sticky; top: 60px; flex-direction: column; align-items: stretch; gap: 12px; margin-top: 0; height: auto; }
                    .header-actions { flex-direction: column; align-items: stretch; width: 100%; gap: 10px; }
                    .segmented-control { width: 100%; display: flex; }
                    .segment-btn { flex: 1; text-align: center; }
                    .hide-mobile { display: none; }
                    .tooltip-down, .tooltip-up { display: none !important; }

                    #ig_account_select_wrapper { width: 100% !important; }

                    #captionSettings, #hashtagSection { flex-wrap: wrap; gap: 8px; }
                    .status-badge { width: 100%; }

                    .ai-capition-btns { flex-direction: column; width: 100%; }
                    .ai-capition-btns button { width: 100%; }

                    #imageSelectModal {
                      width: 90% !important;
                    }
                    #imageSelectModal .image-source-options {
                        grid-template-columns: 1fr !important;
                    }

                    .ai-prompt-container { flex-direction: column; align-items: stretch; padding: 10px; border-radius: var(--radius-sm); gap: 8px; }
                    .ai-prompt-input { padding: 8px; font-size: 14px; }
                    .ai-prompt-container .btn-black { width: 100%; justify-content: center; margin: 0; }

                    .section-hashtag-header { flex-wrap: wrap; gap: 8px; }
                    #hashtag-setting-info { width: 100% !important; }

                    .hashtag-sub-header { flex-wrap: wrap; gap: 8px; }
                    #hashtag-title { width: 100% !important; }
                    #hashtag-ai-button { margin-left: auto !important; }
                }
              }
              .instagram_post_page:not(:has(#templateModal)) em-emoji-picker {
                display: flex !important;
                top: 0px !important;
                left: 0px !important;
              }
              @media (max-width: 800px) {
                .instagram_post_page:not(:has(#templateModal)) em-emoji-picker {
                  left: 0px !important;
                }
              }
          `}</style>
    
          {/* --- [HEADER] --- */}
          <header className="header-row">
            <div className="page-title">게시물 작성</div>
            <div className="header-actions">
              
              <div className="segmented-control">
                <div className="has-tooltip" style={{flex: 1}}>
                    <button className={`segment-btn ${publishOption === 'NOW' ? 'active' : ''}`} onClick={() => this.selectPublishOption('NOW')}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.2844 12.5344L9.34687 16.4719C9.20291 16.6095 9.01166 16.6867 8.8125 16.6875C8.66378 16.6873 8.51849 16.6428 8.3951 16.5598C8.27171 16.4768 8.17578 16.3589 8.11951 16.2213C8.06324 16.0836 8.04917 15.9323 8.07908 15.7867C8.10899 15.641 8.18154 15.5075 8.2875 15.4031L10.9406 12.75H2.25C2.05109 12.75 1.86032 12.671 1.71967 12.5303C1.57902 12.3897 1.5 12.1989 1.5 12C1.5 11.8011 1.57902 11.6103 1.71967 11.4697C1.86032 11.329 2.05109 11.25 2.25 11.25H10.9406L8.2875 8.59687C8.14577 8.45639 8.06566 8.26537 8.06478 8.06581C8.0639 7.86626 8.14233 7.67454 8.28281 7.53281C8.42329 7.39109 8.61432 7.31097 8.81387 7.31009C9.01342 7.30921 9.20515 7.38764 9.34687 7.52813L13.2844 11.4656C13.4252 11.6078 13.5042 11.7999 13.5042 12C13.5042 12.2001 13.4252 12.3922 13.2844 12.5344ZM18 3H12.75C12.5511 3 12.3603 3.07902 12.2197 3.21967C12.079 3.36032 12 3.55109 12 3.75C12 3.94891 12.079 4.13968 12.2197 4.28033C12.3603 4.42098 12.5511 4.5 12.75 4.5H18V19.5H12.75C12.5511 19.5 12.3603 19.579 12.2197 19.7197C12.079 19.8603 12 20.0511 12 20.25C12 20.4489 12.079 20.6397 12.2197 20.7803C12.3603 20.921 12.5511 21 12.75 21H18C18.3978 21 18.7794 20.842 19.0607 20.5607C19.342 20.2794 19.5 19.8978 19.5 19.5V4.5C19.5 4.10218 19.342 3.72064 19.0607 3.43934C18.7794 3.15804 18.3978 3 18 3Z" fill="#333333"/>
                      </svg>
                      즉시 발행
                    </button>
                    <div className="tooltip-down">즉시 인스타그램 업로드</div>
                </div>
                <div className="has-tooltip" style={{flex: 1}}>
                    <button className={`segment-btn ${publishOption === 'SCHEDULED' ? 'active' : ''}`} onClick={() => this.selectPublishOption('SCHEDULED')}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g opacity="0.7">
                          <path d="M19.5 3H17.25V2.25C17.25 2.05109 17.171 1.86032 17.0303 1.71967C16.8897 1.57902 16.6989 1.5 16.5 1.5C16.3011 1.5 16.1103 1.57902 15.9697 1.71967C15.829 1.86032 15.75 2.05109 15.75 2.25V3H8.25V2.25C8.25 2.05109 8.17098 1.86032 8.03033 1.71967C7.88968 1.57902 7.69891 1.5 7.5 1.5C7.30109 1.5 7.11032 1.57902 6.96967 1.71967C6.82902 1.86032 6.75 2.05109 6.75 2.25V3H4.5C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H19.5C19.8978 21 20.2794 20.842 20.5607 20.5607C20.842 20.2794 21 19.8978 21 19.5V4.5C21 4.10218 20.842 3.72064 20.5607 3.43934C20.2794 3.15804 19.8978 3 19.5 3ZM6.75 4.5V5.25C6.75 5.44891 6.82902 5.63968 6.96967 5.78033C7.11032 5.92098 7.30109 6 7.5 6C7.69891 6 7.88968 5.92098 8.03033 5.78033C8.17098 5.63968 8.25 5.44891 8.25 5.25V4.5H15.75V5.25C15.75 5.44891 15.829 5.63968 15.9697 5.78033C16.1103 5.92098 16.3011 6 16.5 6C16.6989 6 16.8897 5.92098 17.0303 5.78033C17.171 5.63968 17.25 5.44891 17.25 5.25V4.5H19.5V7.5H4.5V4.5H6.75ZM19.5 19.5H4.5V9H19.5V19.5Z" fill="#333333"/>
                          <rect x="7" y="11" width="2" height="2" rx="0.3" fill="#333333"/>
                          <rect x="7" y="15" width="2" height="2" rx="0.3" fill="#333333"/>
                          <rect x="11" y="11" width="2" height="2" rx="0.3" fill="#333333"/>
                          <rect x="11" y="15" width="2" height="2" rx="0.3" fill="#333333"/>
                          <rect x="15" y="11" width="2" height="2" rx="0.3" fill="#333333"/>
                          <rect x="15" y="15" width="2" height="2" rx="0.3" fill="#333333"/>
                        </g>
                      </svg>
                      예약 발행
                    </button>
                    <div className="tooltip-down">원하는 날짜와 시간 예약 업로드</div>
                </div>
              </div>
    
              {publishOption === 'SCHEDULED' && (
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  {/* <DatePicker selected={this.getDateObjForDate()} onChange={this.onChangeDatePicker} dateFormat="yyyy-MM-dd" className="custom-date-picker" wrapperClassName="date-wrapper" style={{height:'42px', width:'130px', padding:'0 10px', border:'1px solid #ddd', borderRadius:'8px'}} />
                  <DatePicker selected={this.getDateObjForTime()} onChange={this.onChangeTimePicker} showTimeSelect showTimeSelectOnly dateFormat="HH:mm" className="custom-time-picker" wrapperClassName="time-wrapper" style={{height:'42px', width:'110px', padding:'0 10px', border:'1px solid #ddd', borderRadius:'8px'}} /> */}
                  <DatePicker 
                      selected={this.getDateObjForDate()} 
                      onChange={this.onChangeDatePicker} 
                      dateFormat="yyyy-MM-dd" 
                      className="custom-date-picker" 
                      wrapperClassName="date-wrapper" 
                      placeholderText="날짜 선택"
                  />
                  <DatePicker 
                      selected={this.getDateObjForTime()} 
                      onChange={this.onChangeTimePicker} 
                      showTimeSelect 
                      showTimeSelectOnly 
                      timeFormat="HH:mm" 
                      timeIntervals={30} 
                      timeCaption="시간" 
                      dateFormat="HH:mm" 
                      className="custom-time-picker" 
                      wrapperClassName="time-wrapper" 
                      placeholderText="시간 선택"
                  />
                </div>
              )}
    
              <div className="hide-mobile" style={{ width: '1px', height: '24px', background: '#e5e7eb', margin: '0 4px' }}></div>
    
              <div className="has-tooltip">
                  <div id="ig_account_select_wrapper" style={{ width: '200px' }}>
                  <SelectBoxV2
                      id="ig_account_select"
                      width="100%"
                      height="42px"
                      list={displayAccountList || []}
                      optionTexttName="title"
                      optionValuetName="value"
                      selectedValue={selected_ig_access_seq || default_ig_access_seq || ""}
                      selectedText={selectedAccountText}
                      onClickOption={this.onChangeAccount}
                  />
                  </div>
                  <div className="tooltip-down">발행 계정 선택</div>
              </div>
    
              <div style={{ display: 'flex', gap: '8px', flex: 1 }}>
                  <div className="has-tooltip" style={{flex: 1}}>
                      <button className="btn btn-outline" style={{width: '100%'}} onClick={this.draftPost}>임시 저장</button>
                      <div className="tooltip-down">작성 내용 임시 보관</div>
                  </div>
                  <div className="has-tooltip" style={{flex: 1}}>
                      <button className="btn btn-primary" style={{width: '100%'}} onClick={this.publishPost}>
                      {publishOption === 'NOW' ? '게시물 등록' : '예약 등록'}
                      </button>
                      <div className="tooltip-down">인스타그램 게시물 최종 발행</div>
                  </div>
              </div>
            </div>
          </header>
    
          {/* --- [MAIN] --- */}
          <div className="main-container">
            <nav className="side-nav-area">
              <div className={`nav-item ${activeSection === 'sec-image' ? 'active' : ''}`} onClick={() => this.scrollToSec('sec-image')}>
                <div className="nav-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 15V4.5C21 4.10218 20.842 3.72064 20.5607 3.43934C20.2794 3.15804 19.8978 3 19.5 3H4.5C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H19.5C19.8978 21 20.2794 20.842 20.5607 20.5607C20.842 20.2794 21 19.8978 21 19.5V15ZM19.5 4.5V13.1906L16.8094 10.5C16.527 10.2217 16.1464 10.0658 15.75 10.0658C15.3536 10.0658 14.973 10.2217 14.6906 10.5L10.5 14.6906L8.55938 12.75C8.27698 12.4717 7.89645 12.3158 7.5 12.3158C7.10355 12.3158 6.72302 12.4717 6.44062 12.75L4.5 14.6906V4.5H19.5ZM19.5 19.5H4.5V16.8094L7.5 13.8094L9.44062 15.75C9.72302 16.0283 10.1036 16.1842 10.5 16.1842C10.8964 16.1842 11.277 16.0283 11.5594 15.75L15.75 11.5594L19.5 15.3094V19.5ZM8.57812 9.42188C8.47332 9.31744 8.39034 9.19321 8.33401 9.0564C8.27768 8.91959 8.24912 8.77295 8.25 8.625C8.25 8.32663 8.36853 8.04048 8.5795 7.8295C8.79048 7.61853 9.07663 7.5 9.375 7.5C9.67337 7.5 9.95952 7.61853 10.1705 7.8295C10.3815 8.04048 10.5 8.32663 10.5 8.625C10.5 8.92337 10.3815 9.20952 10.1705 9.4205C9.95952 9.63147 9.67337 9.75 9.375 9.75C9.07695 9.74772 8.79136 9.63013 8.57812 9.42188Z" fill="#333333"/>
                </svg>
                </div><div className="nav-label">이미지</div>
                <div className="nav-tooltip">이미지 및 디자인 제작</div>
              </div>
              <div className={`nav-item ${activeSection === 'sec-caption' ? 'active' : ''}`} onClick={() => this.scrollToSec('sec-caption')}>
                <div className="nav-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 15V4.5C21 4.10218 20.842 3.72064 20.5607 3.43934C20.2794 3.15804 19.8978 3 19.5 3H4.5C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H19.5C19.8978 21 20.2794 20.842 20.5607 20.5607C20.842 20.2794 21 19.8978 21 19.5V15ZM19.5 4.5V13.1906L16.8094 10.5C16.527 10.2217 16.1464 10.0658 15.75 10.0658C15.3536 10.0658 14.973 10.2217 14.6906 10.5L10.5 14.6906L8.55938 12.75C8.27698 12.4717 7.89645 12.3158 7.5 12.3158C7.10355 12.3158 6.72302 12.4717 6.44062 12.75L4.5 14.6906V4.5H19.5ZM19.5 19.5H4.5V16.8094L7.5 13.8094L9.44062 15.75C9.72302 16.0283 10.1036 16.1842 10.5 16.1842C10.8964 16.1842 11.277 16.0283 11.5594 15.75L15.75 11.5594L19.5 15.3094V19.5ZM8.57812 9.42188C8.47332 9.31744 8.39034 9.19321 8.33401 9.0564C8.27768 8.91959 8.24912 8.77295 8.25 8.625C8.25 8.32663 8.36853 8.04048 8.5795 7.8295C8.79048 7.61853 9.07663 7.5 9.375 7.5C9.67337 7.5 9.95952 7.61853 10.1705 7.8295C10.3815 8.04048 10.5 8.32663 10.5 8.625C10.5 8.92337 10.3815 9.20952 10.1705 9.4205C9.95952 9.63147 9.67337 9.75 9.375 9.75C9.07695 9.74772 8.79136 9.63013 8.57812 9.42188Z" fill="#333333"/>
                  </svg>
                </div><div className="nav-label">문구작성</div>
                <div className="nav-tooltip">문구 에디터 및 AI 도구</div>
              </div>
              <div className={`nav-item ${activeSection === 'sec-hashtag' ? 'active' : ''}`} onClick={() => this.scrollToSec('sec-hashtag')}>
                <div className="nav-icon">
                  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 7H14" stroke="#333333" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M4 11H14" stroke="#333333" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M6.31836 14L7.22372 4.04107" stroke="#333333" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M10.8633 14L11.7686 4.04107" stroke="#333333" stroke-width="1.5" stroke-linecap="round"/>
                  </svg>
                </div>
                <div className="nav-label">해시태그</div>
                <div className="nav-tooltip">해시태그 추천 및 관리</div>
              </div>
            </nav>
    
            <main className="input-scroll-area" ref={this.scrollAreaRef}>
              {/* --- [NEW] 계정 연동 안내 배너 --- */}
              {!this.state.accountConnected && !this.state.hideAccountBanner && (
                  <div className="info-banner" id="accountLinkBanner">
                      <div className="info-banner-text">
                          <span style={{ fontSize: '18px' }}>💡</span>
                          아직 인스타그램 계정이 연동되지 않았습니다. 계정을 연동하고 자동 발행을 경험해 보세요!
                      </div>
                      <div style={{ display: 'flex', gap: '8px' }}>
                          <button className="btn btn-outline" style={{ height: '34px', padding: '0 12px', fontSize: '12px' }} onClick={() => this.setState({ hideAccountBanner: true })}>
                              기능 둘러보기
                          </button>
                          {/* 기존에 구현된 handleConnectAccount 함수를 연결합니다 */}
                          <button className="btn btn-purple" style={{ height: '34px', padding: '0 12px', fontSize: '12px' }} onClick={this.handleConnectAccount}>
                              계정 연동하기
                          </button>
                      </div>
                  </div>
              )}
              
              {/* SECTION 1: 이미지 */}
              <section className="card scroll-section" id="sec-image" ref={el => { if(el) this.observer?.observe(el) }}>
                <div className="section-header">
                    <div className="section-title">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21 15V4.5C21 4.10218 20.842 3.72064 20.5607 3.43934C20.2794 3.15804 19.8978 3 19.5 3H4.5C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21H19.5C19.8978 21 20.2794 20.842 20.5607 20.5607C20.842 20.2794 21 19.8978 21 19.5V15ZM19.5 4.5V13.1906L16.8094 10.5C16.527 10.2217 16.1464 10.0658 15.75 10.0658C15.3536 10.0658 14.973 10.2217 14.6906 10.5L10.5 14.6906L8.55938 12.75C8.27698 12.4717 7.89645 12.3158 7.5 12.3158C7.10355 12.3158 6.72302 12.4717 6.44062 12.75L4.5 14.6906V4.5H19.5ZM19.5 19.5H4.5V16.8094L7.5 13.8094L9.44062 15.75C9.72302 16.0283 10.1036 16.1842 10.5 16.1842C10.8964 16.1842 11.277 16.0283 11.5594 15.75L15.75 11.5594L19.5 15.3094V19.5ZM8.57812 9.42188C8.47332 9.31744 8.39034 9.19321 8.33401 9.0564C8.27768 8.91959 8.24912 8.77295 8.25 8.625C8.25 8.32663 8.36853 8.04048 8.5795 7.8295C8.79048 7.61853 9.07663 7.5 9.375 7.5C9.67337 7.5 9.95952 7.61853 10.1705 7.8295C10.3815 8.04048 10.5 8.32663 10.5 8.625C10.5 8.92337 10.3815 9.20952 10.1705 9.4205C9.95952 9.63147 9.67337 9.75 9.375 9.75C9.07695 9.74772 8.79136 9.63013 8.57812 9.42188Z" fill="#333333"/>
                      </svg>
                      이미지 및 디자인 제작
                    </div>
                    {/* <div style={{display:'flex', gap: '10px'}}>
                      <div style={{ display: 'flex', gap: '5px' }}>
                          <button className={`btn btn-outline ${this.state.selectedFeedType === 'SINGLE' ? 'active' : ''}`} onClick={() => this.selectFeedType('SINGLE')} style={{height:'34px', padding: '0 12px', fontSize:'12px'}}>단일</button>
                          <button className={`btn btn-outline ${this.state.selectedFeedType === 'CAROUSEL' ? 'active' : ''}`} onClick={() => this.selectFeedType('CAROUSEL')} style={{height:'34px', padding: '0 12px', fontSize:'12px'}}>슬라이드</button>
                      </div>
                      {this.state.selectedFeedType === "CAROUSEL" && (
                        <button className="btn btn btn-outline" onClick={this.addNewImageSlot} style={{ height: '34px' }}>+ 슬롯 추가</button>
                      )}
                    </div> */}
                </div>
                {this.renderImageSlots()}
              </section>
    
              {/* SECTION 2: 문구 작성 */}
              <section className="card scroll-section" id="sec-caption" ref={el => { if(el) this.observer?.observe(el) }}>
                <div id="captionSettings" className="section-header">
                  <div className="section-title">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21.5306 5.46996L18.5306 2.46996C18.461 2.40023 18.3783 2.34491 18.2872 2.30717C18.1962 2.26943 18.0986 2.25 18 2.25C17.9014 2.25 17.8038 2.26943 17.7128 2.30717C17.6217 2.34491 17.539 2.40023 17.4694 2.46996L8.46937 11.47C8.39975 11.5397 8.34454 11.6224 8.3069 11.7135C8.26926 11.8045 8.24992 11.9021 8.25 12.0006V15.0006C8.25 15.1995 8.32902 15.3903 8.46967 15.5309C8.61032 15.6716 8.80109 15.7506 9 15.7506H12C12.0985 15.7507 12.1961 15.7313 12.2871 15.6937C12.3782 15.6561 12.4609 15.6008 12.5306 15.5312L21.5306 6.53122C21.6004 6.46156 21.6557 6.37884 21.6934 6.2878C21.7312 6.19675 21.7506 6.09915 21.7506 6.00059C21.7506 5.90203 21.7312 5.80443 21.6934 5.71338C21.6557 5.62234 21.6004 5.53962 21.5306 5.46996ZM11.6897 14.2506H9.75V12.3109L15.75 6.3109L17.6897 8.25059L11.6897 14.2506ZM18.75 7.19028L16.8103 5.25059L18 4.0609L19.9397 6.00059L18.75 7.19028ZM21 11.2506V19.5006C21 19.8984 20.842 20.2799 20.5607 20.5612C20.2794 20.8426 19.8978 21.0006 19.5 21.0006H4.5C4.10218 21.0006 3.72064 20.8426 3.43934 20.5612C3.15804 20.2799 3 19.8984 3 19.5006V4.50059C3 4.10277 3.15804 3.72123 3.43934 3.43993C3.72064 3.15863 4.10218 3.00059 4.5 3.00059H12.75C12.9489 3.00059 13.1397 3.07961 13.2803 3.22026C13.421 3.36091 13.5 3.55168 13.5 3.75059C13.5 3.9495 13.421 4.14027 13.2803 4.28092C13.1397 4.42157 12.9489 4.50059 12.75 4.50059H4.5V19.5006H19.5V11.2506C19.5 11.0517 19.579 10.8609 19.7197 10.7203C19.8603 10.5796 20.0511 10.5006 20.25 10.5006C20.4489 10.5006 20.6397 10.5796 20.7803 10.7203C20.921 10.8609 21 11.0517 21 11.2506Z" fill="#333333"/>
                    </svg>
                    문구 작성
                    {/* <button className="icon-btn-purple" onClick={(e) => { e.stopPropagation(); this.toggleModal('captionSettings', true); }} title="설정 변경 안내">
                      <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.5" d="M19.7724 7.39596C19.7502 7.29675 19.7069 7.20343 19.6453 7.12231C19.5837 7.04119 19.5053 6.97417 19.4154 6.92577L17.2914 5.75473C17.1775 5.52521 17.0493 5.30299 16.9076 5.08936L16.9522 2.6763C16.9531 2.57508 16.9329 2.47479 16.8929 2.38168C16.853 2.28857 16.7942 2.20464 16.7202 2.13513C15.6626 1.18194 14.4119 0.465009 13.0522 0.0325761C12.9546 0.00231062 12.8516 -0.00701284 12.75 0.00522155C12.6485 0.017456 12.5507 0.0509698 12.4632 0.103549L10.3838 1.34557C10.1249 1.33669 9.87506 1.33669 9.61624 1.34557L7.53682 0.103549C7.44928 0.0509698 7.35151 0.017456 7.24997 0.00522155C7.14843 -0.00701284 7.04544 0.00231062 6.9478 0.0325761C5.58632 0.465338 4.33507 1.1856 3.2798 2.144C3.20514 2.21112 3.1458 2.29335 3.10578 2.38517C3.06575 2.47698 3.04597 2.57625 3.04776 2.6763L3.09238 5.08936C2.94959 5.30228 2.82465 5.52407 2.6997 5.75473L0.575656 6.92577C0.487054 6.97467 0.410099 7.04199 0.350035 7.12313C0.289971 7.20427 0.24821 7.29733 0.227598 7.39596C-0.075866 8.78144 -0.075866 10.2156 0.227598 11.6011C0.249766 11.7003 0.29311 11.7936 0.354698 11.8747C0.416286 11.9558 0.494681 12.0229 0.584581 12.0713L2.70863 13.2423C2.82249 13.4718 2.95066 13.694 3.09238 13.9077L3.04776 16.3207C3.04695 16.422 3.06713 16.5222 3.10705 16.6154C3.14698 16.7085 3.20578 16.7924 3.2798 16.8619C4.3374 17.8151 5.58812 18.532 6.9478 18.9645C7.04544 18.9947 7.14843 19.0041 7.24997 18.9918C7.35151 18.9796 7.44928 18.9461 7.53682 18.8935L9.61624 17.6515H10.3838L12.4721 18.8935C12.5807 18.9645 12.7081 19.0015 12.838 19C12.9106 18.9968 12.9825 18.9849 13.0522 18.9645C14.4137 18.5317 15.6649 17.8114 16.7202 16.853C16.7949 16.7859 16.8542 16.7037 16.8942 16.6119C16.9342 16.5201 16.954 16.4208 16.9522 16.3207L16.9076 13.9077C17.0504 13.6948 17.1754 13.473 17.3003 13.2423L19.4243 12.0713C19.5129 12.0224 19.5899 11.9551 19.65 11.8739C19.71 11.7928 19.7518 11.6997 19.7724 11.6011C20.0759 10.2156 20.0759 8.78144 19.7724 7.39596ZM18.4337 10.9889L16.4078 12.1068C16.2793 12.181 16.1766 12.2924 16.1133 12.4261C15.9665 12.7285 15.7964 13.0192 15.6046 13.2955C15.5232 13.4195 15.4797 13.5644 15.4797 13.7125L15.5154 16.0102C14.747 16.6606 13.8674 17.1684 12.9183 17.5095L10.9282 16.3207C10.8171 16.2565 10.6908 16.2228 10.5622 16.2232H10.5087C10.1701 16.2498 9.82991 16.2498 9.4913 16.2232C9.34498 16.2152 9.19942 16.2491 9.07185 16.3207L7.08167 17.5095C6.13377 17.1701 5.25434 16.6654 4.48462 16.0191L4.52032 13.7125C4.52026 13.5644 4.47685 13.4195 4.39537 13.2955C4.20684 13.0171 4.03691 12.7267 3.88667 12.4261C3.82078 12.2942 3.71868 12.1835 3.59216 12.1068L1.56628 10.9889C1.38773 10.0033 1.38773 8.99379 1.56628 8.0081L3.59216 6.89028C3.72068 6.81603 3.82341 6.70463 3.88667 6.57091C4.0335 6.26853 4.20357 5.97787 4.39537 5.7015C4.47685 5.57751 4.52026 5.43263 4.52032 5.28453L4.48462 2.9868C5.25298 2.33645 6.13264 1.82862 7.08167 1.48751L9.07185 2.6763C9.19905 2.74892 9.34489 2.78285 9.4913 2.77389C9.82991 2.74727 10.1701 2.74727 10.5087 2.77389C10.655 2.78183 10.8006 2.74797 10.9282 2.6763L12.9183 1.48751C13.8662 1.82698 14.7457 2.33168 15.5154 2.97793L15.4797 5.28453C15.4797 5.43263 15.5232 5.57751 15.6046 5.7015C15.7932 5.97992 15.9631 6.27035 16.1133 6.57091C16.1792 6.70286 16.2813 6.81358 16.4078 6.89028L18.4337 8.0081C18.6123 8.99379 18.6123 10.0033 18.4337 10.9889ZM10 4.53045C9.01154 4.53045 8.04527 4.82182 7.22339 5.36772C6.40152 5.91362 5.76094 6.68953 5.38267 7.59732C5.00441 8.50512 4.90543 9.50403 5.09827 10.4677C5.29111 11.4315 5.7671 12.3167 6.46605 13.0115C7.165 13.7063 8.05552 14.1794 9.02499 14.3711C9.99446 14.5628 10.9993 14.4644 11.9126 14.0884C12.8258 13.7124 13.6063 13.0756 14.1555 12.2586C14.7046 11.4416 14.9978 10.4811 14.9978 9.49852C14.9978 8.18091 14.4712 6.91726 13.5339 5.98557C12.5967 5.05387 11.3255 4.53045 10 4.53045ZM10 13.0471C9.29395 13.0471 8.60377 12.839 8.01671 12.4491C7.42966 12.0592 6.9721 11.5049 6.70191 10.8565C6.43172 10.2081 6.36102 9.49458 6.49877 8.80622C6.63651 8.11785 6.9765 7.48555 7.47575 6.98927C7.975 6.49298 8.61108 6.15501 9.30356 6.01809C9.99604 5.88116 10.7138 5.95144 11.3661 6.22002C12.0184 6.48861 12.5759 6.94345 12.9682 7.52701C13.3605 8.11058 13.5698 8.79667 13.5698 9.49852C13.5698 10.4397 13.1937 11.3423 12.5243 12.0078C11.8548 12.6733 10.9468 13.0471 10 13.0471Z" fill="#6D28D9"/>
                      </svg>
                    </button> */}
                  </div>
                  <span className="setting-link" title="AI 자동 환경설정 메뉴에서 변경할 수 있습니다." style={{ cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); this.toggleModal('captionSettings', true); }}>
                      <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.5" d="M19.7724 7.39596C19.7502 7.29675 19.7069 7.20343 19.6453 7.12231C19.5837 7.04119 19.5053 6.97417 19.4154 6.92577L17.2914 5.75473C17.1775 5.52521 17.0493 5.30299 16.9076 5.08936L16.9522 2.6763C16.9531 2.57508 16.9329 2.47479 16.8929 2.38168C16.853 2.28857 16.7942 2.20464 16.7202 2.13513C15.6626 1.18194 14.4119 0.465009 13.0522 0.0325761C12.9546 0.00231062 12.8516 -0.00701284 12.75 0.00522155C12.6485 0.017456 12.5507 0.0509698 12.4632 0.103549L10.3838 1.34557C10.1249 1.33669 9.87506 1.33669 9.61624 1.34557L7.53682 0.103549C7.44928 0.0509698 7.35151 0.017456 7.24997 0.00522155C7.14843 -0.00701284 7.04544 0.00231062 6.9478 0.0325761C5.58632 0.465338 4.33507 1.1856 3.2798 2.144C3.20514 2.21112 3.1458 2.29335 3.10578 2.38517C3.06575 2.47698 3.04597 2.57625 3.04776 2.6763L3.09238 5.08936C2.94959 5.30228 2.82465 5.52407 2.6997 5.75473L0.575656 6.92577C0.487054 6.97467 0.410099 7.04199 0.350035 7.12313C0.289971 7.20427 0.24821 7.29733 0.227598 7.39596C-0.075866 8.78144 -0.075866 10.2156 0.227598 11.6011C0.249766 11.7003 0.29311 11.7936 0.354698 11.8747C0.416286 11.9558 0.494681 12.0229 0.584581 12.0713L2.70863 13.2423C2.82249 13.4718 2.95066 13.694 3.09238 13.9077L3.04776 16.3207C3.04695 16.422 3.06713 16.5222 3.10705 16.6154C3.14698 16.7085 3.20578 16.7924 3.2798 16.8619C4.3374 17.8151 5.58812 18.532 6.9478 18.9645C7.04544 18.9947 7.14843 19.0041 7.24997 18.9918C7.35151 18.9796 7.44928 18.9461 7.53682 18.8935L9.61624 17.6515H10.3838L12.4721 18.8935C12.5807 18.9645 12.7081 19.0015 12.838 19C12.9106 18.9968 12.9825 18.9849 13.0522 18.9645C14.4137 18.5317 15.6649 17.8114 16.7202 16.853C16.7949 16.7859 16.8542 16.7037 16.8942 16.6119C16.9342 16.5201 16.954 16.4208 16.9522 16.3207L16.9076 13.9077C17.0504 13.6948 17.1754 13.473 17.3003 13.2423L19.4243 12.0713C19.5129 12.0224 19.5899 11.9551 19.65 11.8739C19.71 11.7928 19.7518 11.6997 19.7724 11.6011C20.0759 10.2156 20.0759 8.78144 19.7724 7.39596ZM18.4337 10.9889L16.4078 12.1068C16.2793 12.181 16.1766 12.2924 16.1133 12.4261C15.9665 12.7285 15.7964 13.0192 15.6046 13.2955C15.5232 13.4195 15.4797 13.5644 15.4797 13.7125L15.5154 16.0102C14.747 16.6606 13.8674 17.1684 12.9183 17.5095L10.9282 16.3207C10.8171 16.2565 10.6908 16.2228 10.5622 16.2232H10.5087C10.1701 16.2498 9.82991 16.2498 9.4913 16.2232C9.34498 16.2152 9.19942 16.2491 9.07185 16.3207L7.08167 17.5095C6.13377 17.1701 5.25434 16.6654 4.48462 16.0191L4.52032 13.7125C4.52026 13.5644 4.47685 13.4195 4.39537 13.2955C4.20684 13.0171 4.03691 12.7267 3.88667 12.4261C3.82078 12.2942 3.71868 12.1835 3.59216 12.1068L1.56628 10.9889C1.38773 10.0033 1.38773 8.99379 1.56628 8.0081L3.59216 6.89028C3.72068 6.81603 3.82341 6.70463 3.88667 6.57091C4.0335 6.26853 4.20357 5.97787 4.39537 5.7015C4.47685 5.57751 4.52026 5.43263 4.52032 5.28453L4.48462 2.9868C5.25298 2.33645 6.13264 1.82862 7.08167 1.48751L9.07185 2.6763C9.19905 2.74892 9.34489 2.78285 9.4913 2.77389C9.82991 2.74727 10.1701 2.74727 10.5087 2.77389C10.655 2.78183 10.8006 2.74797 10.9282 2.6763L12.9183 1.48751C13.8662 1.82698 14.7457 2.33168 15.5154 2.97793L15.4797 5.28453C15.4797 5.43263 15.5232 5.57751 15.6046 5.7015C15.7932 5.97992 15.9631 6.27035 16.1133 6.57091C16.1792 6.70286 16.2813 6.81358 16.4078 6.89028L18.4337 8.0081C18.6123 8.99379 18.6123 10.0033 18.4337 10.9889ZM10 4.53045C9.01154 4.53045 8.04527 4.82182 7.22339 5.36772C6.40152 5.91362 5.76094 6.68953 5.38267 7.59732C5.00441 8.50512 4.90543 9.50403 5.09827 10.4677C5.29111 11.4315 5.7671 12.3167 6.46605 13.0115C7.165 13.7063 8.05552 14.1794 9.02499 14.3711C9.99446 14.5628 10.9993 14.4644 11.9126 14.0884C12.8258 13.7124 13.6063 13.0756 14.1555 12.2586C14.7046 11.4416 14.9978 10.4811 14.9978 9.49852C14.9978 8.18091 14.4712 6.91726 13.5339 5.98557C12.5967 5.05387 11.3255 4.53045 10 4.53045ZM10 13.0471C9.29395 13.0471 8.60377 12.839 8.01671 12.4491C7.42966 12.0592 6.9721 11.5049 6.70191 10.8565C6.43172 10.2081 6.36102 9.49458 6.49877 8.80622C6.63651 8.11785 6.9765 7.48555 7.47575 6.98927C7.975 6.49298 8.61108 6.15501 9.30356 6.01809C9.99604 5.88116 10.7138 5.95144 11.3661 6.22002C12.0184 6.48861 12.5759 6.94345 12.9682 7.52701C13.3605 8.11058 13.5698 8.79667 13.5698 9.49852C13.5698 10.4397 13.1937 11.3423 12.5243 12.0078C11.8548 12.6733 10.9468 13.0471 10 13.0471Z" fill="#6b7280"></path></svg> 
                      설정 기준: 회당 {caption_setting_count}개
                  </span>
                </div>
    
                {/* Quick Phrase Chips */}
                <div style={{ marginBottom: '12px' }}>
                    <div className="chip-container">
                        <div className="has-tooltip">
                            <div className="phrase-chip chip-new" onClick={() => this.toggleModal('phrase', true)}>+ 즐겨찾는 문구 추가</div>
                            <div className="tooltip-down">자주 쓰는 문구 저장</div>
                        </div>
                        
                        {quickPhrases.map((phrase, idx) => (
                            <div key={idx} className="phrase-chip" onClick={() => this.appendPhraseText(phrase.content)}>
                                {phrase.title} <span className="chip-delete" onClick={(e) => { e.stopPropagation(); this.removePhrase(idx); }}>×</span>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Toolbar & Textarea */}
                <div>
                    <div className="toolbar">
                        <button className="tool-btn" onClick={this.undoCaption}>↩</button>
                        <button className="tool-btn" onClick={this.redoCaption}>↪</button>
                        <button ref={this.triggerRef} className="tool-btn" onClick={this.showEmojiPicker}>🙂 이모지</button>
                    </div>
                    
                    {this.state.emojiPickerVisible && (
                      <div ref={this.pickerRef} style={{ position: 'absolute', zIndex: 999, transform: 'translateY(5px)' }}>
                        <Picker data={data} onEmojiSelect={emoji => this.handleEmojiSelect(emoji)} />
                      </div>
                    )}

                    <textarea
                        ref={this.captionTextareaRef}
                        className="form-control"
                        style={{ borderRadius: "0 0 8px 8px", minHeight: "150px" }}
                        placeholder="문구를 직접 작성하거나, 하단의 AI 생성 문구를 적용하세요."
                        value={caption}
                        maxLength={maxCaptionLength}
                        onChange={this.onChangeCaption}
                    />
                    {/* 글자 수가 꽉 찼을 때 빨간색으로 경고 */}
                    <div style={{ 
                        textAlign: "right", 
                        fontSize: "12px", 
                        color: caption.length > maxCaptionLength ? "#dc2626" : "#8e8e8e", /* 2200자 도달 시 빨간색(#dc2626)으로 변경 */
                        marginTop: "5px" 
                    }}>
                        {caption.length.toLocaleString()}/{maxCaptionLength.toLocaleString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
                    </div>
                </div>
    
                {/* AI 카피라이터 영역 */}
                <div className="ai-section">
                  <div className="ai-header-row">
                    <div style={{ fontWeight: "800", fontSize: "18px", color: "var(--deep-navy)", display: "flex", alignItems: "center", gap: 5 }}>
                      <div style={{ padding: "4px 0px 4px 4px", display: "flex", alignItems: "center" }}>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M12.6045 2.91895C12.6933 2.52695 13.0827 2.27738 13.4775 2.36914L13.4766 2.37012C16.6104 3.08004 19.0699 5.56761 19.7754 8.72559L21.9834 12.5645L22.0596 12.7197C22.3774 13.5086 21.7906 14.4323 20.9062 14.4326H19.5908V16.7891C19.5908 17.7583 18.8075 18.5488 17.8428 18.5488H16.5225V20.4023C16.5222 21.3656 15.7415 22.1494 14.7803 22.1494H8.11621C7.14877 22.1493 6.36343 21.3601 6.36328 20.3906C6.36328 18.75 5.82036 17.0792 4.78711 15.5605H4.78613C4.04577 14.4618 3.55002 13.0784 3.38574 11.6631C3.33952 11.2634 3.62562 10.9012 4.02539 10.8545L4.10059 10.8496C4.47401 10.8424 4.79136 11.1215 4.83398 11.4951C4.97227 12.6863 5.38525 13.8398 5.99316 14.7422C7.18602 16.496 7.82129 18.45 7.82129 20.3906C7.82145 20.5542 7.95964 20.6913 8.11621 20.6914H14.7803C14.9347 20.6914 15.0642 20.5636 15.0645 20.4023V17.8193C15.0646 17.4169 15.3911 17.0908 15.7939 17.0908H17.8428C17.9989 17.0908 18.1328 16.9589 18.1328 16.7891V13.7031C18.1329 13.3007 18.4595 12.9746 18.8623 12.9746H20.5381C20.4791 12.8713 20.402 12.7368 20.3125 12.5801C20.1001 12.2083 19.8169 11.7112 19.5332 11.2129C19.2496 10.7147 18.965 10.2144 18.751 9.83496C18.644 9.64536 18.5545 9.48546 18.4912 9.37109C18.4596 9.314 18.4338 9.2676 18.416 9.23438C18.4073 9.21812 18.4 9.2042 18.3945 9.19336C18.3919 9.1881 18.3892 9.1821 18.3867 9.17676C18.3855 9.17412 18.3835 9.17025 18.3818 9.16602C18.381 9.16395 18.3769 9.15324 18.374 9.13965C17.8193 6.48245 15.7699 4.38268 13.1543 3.79004C12.7618 3.70116 12.5157 3.31129 12.6045 2.91895Z" fill="black" stroke="black" stroke-width="0.3"/>
                          <mask id="path-2-inside-1_12286_116124" fill="white">
                          <path d="M4.8835 2.40343C4.6993 1.91228 3.98343 1.91251 3.7991 2.40343L2.06226 7.035C1.95032 7.33437 2.10184 7.66794 2.40092 7.78046C2.70001 7.89071 3.03415 7.74116 3.14666 7.44151L3.37797 6.82469H5.30464C5.30464 6.82469 5.53523 7.4396 5.53594 7.44151C5.64729 7.73842 5.98678 7.88949 6.28168 7.78046C6.58076 7.66794 6.73229 7.33437 6.62034 7.035C6.62034 7.035 4.88742 2.41387 4.8835 2.40343ZM3.81215 5.66679L4.3413 4.25561L4.87046 5.66679H3.81215Z"/>
                          </mask>
                          <path d="M4.8835 2.40343C4.6993 1.91228 3.98343 1.91251 3.7991 2.40343L2.06226 7.035C1.95032 7.33437 2.10184 7.66794 2.40092 7.78046C2.70001 7.89071 3.03415 7.74116 3.14666 7.44151L3.37797 6.82469H5.30464C5.30464 6.82469 5.53523 7.4396 5.53594 7.44151C5.64729 7.73842 5.98678 7.88949 6.28168 7.78046C6.58076 7.66794 6.73229 7.33437 6.62034 7.035C6.62034 7.035 4.88742 2.41387 4.8835 2.40343ZM3.81215 5.66679L4.3413 4.25561L4.87046 5.66679H3.81215Z" fill="black"/>
                          <path d="M4.8835 2.40343L3.47902 2.93016L3.47913 2.93045L4.8835 2.40343ZM3.7991 2.40343L2.39483 1.87616L2.39461 1.87674L3.7991 2.40343ZM2.06226 7.035L0.657767 6.50832L0.657278 6.50963L2.06226 7.035ZM2.40092 7.78046L1.87276 9.18443L1.88212 9.18788L2.40092 7.78046ZM3.14666 7.44151L4.55093 7.96879L4.55115 7.9682L3.14666 7.44151ZM3.37797 6.82469V5.32469H2.33847L1.97348 6.298L3.37797 6.82469ZM5.30464 6.82469L6.70913 6.298L6.34414 5.32469H5.30464V6.82469ZM5.53594 7.44151L4.13092 7.96679L4.13145 7.9682L5.53594 7.44151ZM6.28168 7.78046L6.80187 9.1874L6.80983 9.1844L6.28168 7.78046ZM6.62034 7.035L8.02533 6.50963L8.02484 6.50832L6.62034 7.035ZM3.81215 5.66679L2.40764 5.14014L1.6477 7.16679H3.81215V5.66679ZM4.3413 4.25561L5.74581 3.72895L4.34131 -0.0166507L2.9368 3.72895L4.3413 4.25561ZM4.87046 5.66679V7.16679H7.03491L6.27497 5.14014L4.87046 5.66679ZM4.8835 2.40343L6.28798 1.8767C5.61655 0.0864211 3.06559 0.0897112 2.39483 1.87616L3.7991 2.40343L5.20338 2.9307C5.04542 3.35139 4.65019 3.53512 4.34154 3.53516C4.03267 3.5352 3.63696 3.35127 3.47902 2.93016L4.8835 2.40343ZM3.7991 2.40343L2.39461 1.87674L0.657768 6.50832L2.06226 7.035L3.46676 7.56169L5.2036 2.93011L3.7991 2.40343ZM2.06226 7.035L0.657278 6.50963C0.255739 7.58344 0.798969 8.78045 1.87277 9.1844L2.40092 7.78046L2.92907 6.37651C3.40471 6.55544 3.64489 7.08531 3.46724 7.56038L2.06226 7.035ZM2.40092 7.78046L1.88212 9.18788C2.9435 9.57913 4.14409 9.05231 4.55093 7.96879L3.14666 7.44151L1.74239 6.91424C1.9242 6.43002 2.45652 6.20228 2.91973 6.37303L2.40092 7.78046ZM3.14666 7.44151L4.55115 7.9682L4.78246 7.35137L3.37797 6.82469L1.97348 6.298L1.74217 6.91482L3.14666 7.44151ZM3.37797 6.82469V8.32469H5.30464V6.82469V5.32469H3.37797V6.82469ZM5.30464 6.82469C3.90014 7.35137 3.90015 7.35137 3.90015 7.35138C3.90015 7.35138 3.90015 7.35139 3.90016 7.3514C3.90016 7.35142 3.90017 7.35145 3.90019 7.35148C3.90021 7.35156 3.90026 7.35167 3.90031 7.35182C3.90042 7.35211 3.90059 7.35255 3.90081 7.35314C3.90124 7.3543 3.90189 7.35603 3.90273 7.35828C3.90442 7.36278 3.9069 7.36939 3.91005 7.3778C3.91636 7.39462 3.92537 7.41864 3.93619 7.44748C3.95782 7.50516 3.98666 7.58208 4.01553 7.65907C4.0444 7.73605 4.07329 7.81309 4.09501 7.87101C4.11707 7.92983 4.1311 7.96725 4.13093 7.96679L5.53594 7.44151L6.94096 6.91623C6.94026 6.91434 6.88191 6.75874 6.82452 6.6057C6.79565 6.52871 6.7668 6.45179 6.74517 6.39411C6.73436 6.36527 6.72535 6.34124 6.71904 6.32442C6.71589 6.31602 6.71341 6.30941 6.71172 6.3049C6.71088 6.30265 6.71023 6.30093 6.70979 6.29976C6.70957 6.29918 6.70941 6.29874 6.7093 6.29844C6.70924 6.2983 6.7092 6.29818 6.70917 6.29811C6.70916 6.29807 6.70915 6.29804 6.70914 6.29803C6.70914 6.29802 6.70914 6.29801 6.70913 6.29801C6.70913 6.298 6.70913 6.298 5.30464 6.82469ZM5.53594 7.44151L4.13145 7.9682C4.53748 9.05093 5.74525 9.57803 6.80186 9.18737L6.28168 7.78046L5.7615 6.37354C6.22831 6.20094 6.7571 6.42591 6.94044 6.91482L5.53594 7.44151ZM6.28168 7.78046L6.80983 9.1844C7.88363 8.78045 8.42686 7.58344 8.02532 6.50963L6.62034 7.035L5.21536 7.56038C5.03771 7.08531 5.2779 6.55544 5.75353 6.37651L6.28168 7.78046ZM6.62034 7.035C8.02484 6.50832 8.02483 6.5083 8.02482 6.50827C8.0248 6.50823 8.02478 6.50818 8.02476 6.50811C8.0247 6.50797 8.02462 6.50776 8.02452 6.50748C8.02431 6.50692 8.024 6.50608 8.02358 6.50497C8.02275 6.50275 8.0215 6.49944 8.01986 6.49506C8.01659 6.48632 8.01172 6.47334 8.00537 6.45642C7.99268 6.42257 7.97406 6.37293 7.95037 6.30974C7.90297 6.18336 7.83527 6.0028 7.75401 5.7861C7.59148 5.35271 7.37474 4.77474 7.15788 4.19645C6.72425 3.04008 6.28991 1.88185 6.28787 1.8764L4.8835 2.40343L3.47913 2.93045C3.47912 2.93041 3.4795 2.93143 3.48045 2.93397C3.48134 2.93634 3.48264 2.9398 3.48434 2.94433C3.48773 2.95338 3.49271 2.96664 3.49916 2.98385C3.51207 3.01827 3.53088 3.06845 3.55476 3.13213C3.60252 3.25948 3.67054 3.44085 3.75204 3.6582C3.91505 4.0929 4.13204 4.67152 4.3489 5.24982C4.56576 5.82811 4.78249 6.40608 4.94502 6.83947C5.02628 7.05617 5.09399 7.23672 5.14138 7.3631C5.16507 7.42629 5.18369 7.47594 5.19639 7.50979C5.20273 7.52671 5.2076 7.53969 5.21088 7.54843C5.21252 7.5528 5.21376 7.55612 5.21459 7.55834C5.21501 7.55945 5.21532 7.56029 5.21553 7.56085C5.21564 7.56113 5.21571 7.56134 5.21577 7.56148C5.21579 7.56155 5.21581 7.5616 5.21583 7.56164C5.21584 7.56167 5.21585 7.56169 6.62034 7.035ZM3.81215 5.66679L5.21665 6.19344L5.74581 4.78226L4.3413 4.25561L2.9368 3.72895L2.40764 5.14014L3.81215 5.66679ZM4.3413 4.25561L2.9368 4.78226L3.46596 6.19344L4.87046 5.66679L6.27497 5.14014L5.74581 3.72895L4.3413 4.25561ZM4.87046 5.66679V4.16679H3.81215V5.66679V7.16679H4.87046V5.66679Z" fill="black" mask="url(#path-2-inside-1_12286_116124)"/>
                          <path d="M8.39551 1.87695C8.79802 1.87704 9.12402 2.20391 9.12402 2.60645C9.12394 3.00891 8.79797 3.33488 8.39551 3.33496C7.99297 3.33496 7.6661 3.00896 7.66602 2.60645C7.66602 2.20386 7.99292 1.87695 8.39551 1.87695Z" fill="black" stroke="black" stroke-width="0.3"/>
                          <mask id="path-5-inside-2_12286_116124" fill="white">
                          <path d="M8.97317 6.65645V4.34067C8.97317 4.02094 8.71422 3.76172 8.39422 3.76172H7.81528C7.49527 3.76172 7.23633 4.02094 7.23633 4.34067C7.23633 4.66039 7.49527 4.91961 7.81528 4.91961V7.2354C7.81528 7.55513 8.07422 7.81435 8.39422 7.81435H8.97317C9.29317 7.81435 9.55212 7.55513 9.55212 7.2354C9.55212 6.91568 9.29317 6.65645 8.97317 6.65645Z"/>
                          </mask>
                          <path d="M8.97317 6.65645V4.34067C8.97317 4.02094 8.71422 3.76172 8.39422 3.76172H7.81528C7.49527 3.76172 7.23633 4.02094 7.23633 4.34067C7.23633 4.66039 7.49527 4.91961 7.81528 4.91961V7.2354C7.81528 7.55513 8.07422 7.81435 8.39422 7.81435H8.97317C9.29317 7.81435 9.55212 7.55513 9.55212 7.2354C9.55212 6.91568 9.29317 6.65645 8.97317 6.65645Z" fill="black"/>
                          <path d="M8.97317 6.65645H7.47317V8.15645H8.97317V6.65645ZM7.81528 4.91961H9.31528V3.41961H7.81528V4.91961ZM8.97317 6.65645H10.4732V4.34067H8.97317H7.47317V6.65645H8.97317ZM8.97317 4.34067H10.4732C10.4732 3.19298 9.54312 2.26172 8.39422 2.26172V3.76172V5.26172C7.88533 5.26172 7.47317 4.8489 7.47317 4.34067H8.97317ZM8.39422 3.76172V2.26172H7.81528V3.76172V5.26172H8.39422V3.76172ZM7.81528 3.76172V2.26172C6.66638 2.26172 5.73633 3.19298 5.73633 4.34067H7.23633H8.73633C8.73633 4.8489 8.32417 5.26172 7.81528 5.26172V3.76172ZM7.23633 4.34067H5.73633C5.73633 5.48835 6.66638 6.41961 7.81528 6.41961V4.91961V3.41961C8.32417 3.41961 8.73633 3.83243 8.73633 4.34067H7.23633ZM7.81528 4.91961H6.31528V7.2354H7.81528H9.31528V4.91961H7.81528ZM7.81528 7.2354H6.31528C6.31528 8.38308 7.24532 9.31435 8.39422 9.31435V7.81435V6.31435C8.90312 6.31435 9.31528 6.72717 9.31528 7.2354H7.81528ZM8.39422 7.81435V9.31435H8.97317V7.81435V6.31435H8.39422V7.81435ZM8.97317 7.81435V9.31435C10.1221 9.31435 11.0521 8.38308 11.0521 7.2354H9.55212H8.05212C8.05212 6.72717 8.46428 6.31435 8.97317 6.31435V7.81435ZM9.55212 7.2354H11.0521C11.0521 6.08772 10.1221 5.15645 8.97317 5.15645V6.65645V8.15645C8.46428 8.15645 8.05212 7.74364 8.05212 7.2354H9.55212Z" fill="black" mask="url(#path-5-inside-2_12286_116124)"/>
                          <mask id="path-7-inside-3_12286_116124" fill="white">
                          <path d="M11.5789 8.10526V1.73684C11.5789 0.779089 10.7999 0 9.8421 0H1.73684C0.779089 0 0 0.779089 0 1.73684V8.10526C0 9.06301 0.779089 9.8421 1.73684 9.8421H9.8421C10.7999 9.8421 11.5789 9.06301 11.5789 8.10526ZM1.15789 8.10526V1.73684C1.15789 1.41769 1.4174 1.15789 1.73684 1.15789H9.8421C10.1615 1.15789 10.421 1.41769 10.421 1.73684V8.10526C10.421 8.42442 10.1615 8.68421 9.8421 8.68421H1.73684C1.4174 8.68421 1.15789 8.42442 1.15789 8.10526Z"/>
                          </mask>
                          <path d="M11.5789 8.10526V1.73684C11.5789 0.779089 10.7999 0 9.8421 0H1.73684C0.779089 0 0 0.779089 0 1.73684V8.10526C0 9.06301 0.779089 9.8421 1.73684 9.8421H9.8421C10.7999 9.8421 11.5789 9.06301 11.5789 8.10526ZM1.15789 8.10526V1.73684C1.15789 1.41769 1.4174 1.15789 1.73684 1.15789H9.8421C10.1615 1.15789 10.421 1.41769 10.421 1.73684V8.10526C10.421 8.42442 10.1615 8.68421 9.8421 8.68421H1.73684C1.4174 8.68421 1.15789 8.42442 1.15789 8.10526Z" fill="black"/>
                          <path d="M11.5789 8.10526H13.5789V1.73684H11.5789H9.57894V8.10526H11.5789ZM11.5789 1.73684H13.5789C13.5789 -0.32548 11.9044 -2 9.8421 -2V0V2C9.69528 2 9.57894 1.88366 9.57894 1.73684H11.5789ZM9.8421 0V-2H1.73684V0V2H9.8421V0ZM1.73684 0V-2C-0.32548 -2 -2 -0.32548 -2 1.73684H0H2C2 1.88366 1.88366 2 1.73684 2V0ZM0 1.73684H-2V8.10526H0H2V1.73684H0ZM0 8.10526H-2C-2 10.1676 -0.32548 11.8421 1.73684 11.8421V9.8421V7.8421C1.88366 7.8421 2 7.95844 2 8.10526H0ZM1.73684 9.8421V11.8421H9.8421V9.8421V7.8421H1.73684V9.8421ZM9.8421 9.8421V11.8421C11.9044 11.8421 13.5789 10.1676 13.5789 8.10526H11.5789H9.57894C9.57894 7.95844 9.69528 7.8421 9.8421 7.8421V9.8421ZM1.15789 8.10526H3.15789V1.73684H1.15789H-0.842106V8.10526H1.15789ZM1.15789 1.73684H3.15789C3.15789 2.52162 2.52261 3.15789 1.73684 3.15789V1.15789V-0.842106C0.312194 -0.842106 -0.842106 0.313754 -0.842106 1.73684H1.15789ZM1.73684 1.15789V3.15789H9.8421V1.15789V-0.842106H1.73684V1.15789ZM9.8421 1.15789V3.15789C9.05633 3.15789 8.42105 2.52162 8.42105 1.73684H10.421H12.421C12.421 0.313754 11.2667 -0.842106 9.8421 -0.842106V1.15789ZM10.421 1.73684H8.42105V8.10526H10.421H12.421V1.73684H10.421ZM10.421 8.10526H8.42105C8.42105 7.32049 9.05633 6.68421 9.8421 6.68421V8.68421V10.6842C11.2667 10.6842 12.421 9.52835 12.421 8.10526H10.421ZM9.8421 8.68421V6.68421H1.73684V8.68421V10.6842H9.8421V8.68421ZM1.73684 8.68421V6.68421C2.52261 6.68421 3.15789 7.32049 3.15789 8.10526H1.15789H-0.842106C-0.842106 9.52835 0.312194 10.6842 1.73684 10.6842V8.68421Z" fill="black" mask="url(#path-7-inside-3_12286_116124)"/>
                        </svg>
                      </div>
                      AI 카피라이터 제작
                    </div>

                    <div className="ai-capition-btns" style={{ display: 'flex', gap: '8px' }}>
                        <div className="has-tooltip">
                            <button className="btn btn-purple" onClick={() => this.toggleModal('styleConfig', true)}>
                              <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path opacity="0.5" d="M19.7724 7.39596C19.7502 7.29675 19.7069 7.20343 19.6453 7.12231C19.5837 7.04119 19.5053 6.97417 19.4154 6.92577L17.2914 5.75473C17.1775 5.52521 17.0493 5.30299 16.9076 5.08936L16.9522 2.6763C16.9531 2.57508 16.9329 2.47479 16.8929 2.38168C16.853 2.28857 16.7942 2.20464 16.7202 2.13513C15.6626 1.18194 14.4119 0.465009 13.0522 0.0325761C12.9546 0.00231062 12.8516 -0.00701284 12.75 0.00522155C12.6485 0.017456 12.5507 0.0509698 12.4632 0.103549L10.3838 1.34557C10.1249 1.33669 9.87506 1.33669 9.61624 1.34557L7.53682 0.103549C7.44928 0.0509698 7.35151 0.017456 7.24997 0.00522155C7.14843 -0.00701284 7.04544 0.00231062 6.9478 0.0325761C5.58632 0.465338 4.33507 1.1856 3.2798 2.144C3.20514 2.21112 3.1458 2.29335 3.10578 2.38517C3.06575 2.47698 3.04597 2.57625 3.04776 2.6763L3.09238 5.08936C2.94959 5.30228 2.82465 5.52407 2.6997 5.75473L0.575656 6.92577C0.487054 6.97467 0.410099 7.04199 0.350035 7.12313C0.289971 7.20427 0.24821 7.29733 0.227598 7.39596C-0.075866 8.78144 -0.075866 10.2156 0.227598 11.6011C0.249766 11.7003 0.29311 11.7936 0.354698 11.8747C0.416286 11.9558 0.494681 12.0229 0.584581 12.0713L2.70863 13.2423C2.82249 13.4718 2.95066 13.694 3.09238 13.9077L3.04776 16.3207C3.04695 16.422 3.06713 16.5222 3.10705 16.6154C3.14698 16.7085 3.20578 16.7924 3.2798 16.8619C4.3374 17.8151 5.58812 18.532 6.9478 18.9645C7.04544 18.9947 7.14843 19.0041 7.24997 18.9918C7.35151 18.9796 7.44928 18.9461 7.53682 18.8935L9.61624 17.6515H10.3838L12.4721 18.8935C12.5807 18.9645 12.7081 19.0015 12.838 19C12.9106 18.9968 12.9825 18.9849 13.0522 18.9645C14.4137 18.5317 15.6649 17.8114 16.7202 16.853C16.7949 16.7859 16.8542 16.7037 16.8942 16.6119C16.9342 16.5201 16.954 16.4208 16.9522 16.3207L16.9076 13.9077C17.0504 13.6948 17.1754 13.473 17.3003 13.2423L19.4243 12.0713C19.5129 12.0224 19.5899 11.9551 19.65 11.8739C19.71 11.7928 19.7518 11.6997 19.7724 11.6011C20.0759 10.2156 20.0759 8.78144 19.7724 7.39596ZM18.4337 10.9889L16.4078 12.1068C16.2793 12.181 16.1766 12.2924 16.1133 12.4261C15.9665 12.7285 15.7964 13.0192 15.6046 13.2955C15.5232 13.4195 15.4797 13.5644 15.4797 13.7125L15.5154 16.0102C14.747 16.6606 13.8674 17.1684 12.9183 17.5095L10.9282 16.3207C10.8171 16.2565 10.6908 16.2228 10.5622 16.2232H10.5087C10.1701 16.2498 9.82991 16.2498 9.4913 16.2232C9.34498 16.2152 9.19942 16.2491 9.07185 16.3207L7.08167 17.5095C6.13377 17.1701 5.25434 16.6654 4.48462 16.0191L4.52032 13.7125C4.52026 13.5644 4.47685 13.4195 4.39537 13.2955C4.20684 13.0171 4.03691 12.7267 3.88667 12.4261C3.82078 12.2942 3.71868 12.1835 3.59216 12.1068L1.56628 10.9889C1.38773 10.0033 1.38773 8.99379 1.56628 8.0081L3.59216 6.89028C3.72068 6.81603 3.82341 6.70463 3.88667 6.57091C4.0335 6.26853 4.20357 5.97787 4.39537 5.7015C4.47685 5.57751 4.52026 5.43263 4.52032 5.28453L4.48462 2.9868C5.25298 2.33645 6.13264 1.82862 7.08167 1.48751L9.07185 2.6763C9.19905 2.74892 9.34489 2.78285 9.4913 2.77389C9.82991 2.74727 10.1701 2.74727 10.5087 2.77389C10.655 2.78183 10.8006 2.74797 10.9282 2.6763L12.9183 1.48751C13.8662 1.82698 14.7457 2.33168 15.5154 2.97793L15.4797 5.28453C15.4797 5.43263 15.5232 5.57751 15.6046 5.7015C15.7932 5.97992 15.9631 6.27035 16.1133 6.57091C16.1792 6.70286 16.2813 6.81358 16.4078 6.89028L18.4337 8.0081C18.6123 8.99379 18.6123 10.0033 18.4337 10.9889ZM10 4.53045C9.01154 4.53045 8.04527 4.82182 7.22339 5.36772C6.40152 5.91362 5.76094 6.68953 5.38267 7.59732C5.00441 8.50512 4.90543 9.50403 5.09827 10.4677C5.29111 11.4315 5.7671 12.3167 6.46605 13.0115C7.165 13.7063 8.05552 14.1794 9.02499 14.3711C9.99446 14.5628 10.9993 14.4644 11.9126 14.0884C12.8258 13.7124 13.6063 13.0756 14.1555 12.2586C14.7046 11.4416 14.9978 10.4811 14.9978 9.49852C14.9978 8.18091 14.4712 6.91726 13.5339 5.98557C12.5967 5.05387 11.3255 4.53045 10 4.53045ZM10 13.0471C9.29395 13.0471 8.60377 12.839 8.01671 12.4491C7.42966 12.0592 6.9721 11.5049 6.70191 10.8565C6.43172 10.2081 6.36102 9.49458 6.49877 8.80622C6.63651 8.11785 6.9765 7.48555 7.47575 6.98927C7.975 6.49298 8.61108 6.15501 9.30356 6.01809C9.99604 5.88116 10.7138 5.95144 11.3661 6.22002C12.0184 6.48861 12.5759 6.94345 12.9682 7.52701C13.3605 8.11058 13.5698 8.79667 13.5698 9.49852C13.5698 10.4397 13.1937 11.3423 12.5243 12.0078C11.8548 12.6733 10.9468 13.0471 10 13.0471Z" fill="#6D28D9"/>
                              </svg>
                              스타일 설정
                            </button>
                            <div className="tooltip-down">AI 브랜드 톤앤매너 설정</div>
                        </div>
                        {/* <button className="btn btn-black" onClick={this.generateAICaption}>✨ AI 생성하기</button> */}
                    </div>
                  </div>
                  
                  {
                    this.state.gptUsage["is_api_limit_apply_yn"] == "Y" &&
                    <div className="gpt-usage-inline">
                      {this.state.gptUsageLoading ? (
                        "AI 사용량 불러오는 중..."
                      ) : (
                        <>
                          AI 호출량 :{" "}
                          <span style={{ fontWeight: 500, color: "#0A1A2F" }}>
                            {Number(this.state.gptUsage.total_used_gpt_char_count || 0).toLocaleString()}
                          </span>
                          {" / "}
                          <span style={{ fontWeight: 500, color: "#0A1A2F" }}>
                            {Number(this.state.gptUsage.total_available_gpt_char_count || 0).toLocaleString()}
                          </span>
                          {" "}
                          <span style={{ color: "#0284c7", fontWeight: 500 }}>
                            (남은 호출량 {Number(this.state.gptUsage.max_available_gpt_char_count || 0).toLocaleString()}자)
                          </span>
                        </>
                      )}
                    </div>
                  }
                  
                  {/* <div style={{ marginBottom: "16px" }}>
                    <TextInput type="text" id="topicInput" placeholder="예: 신제품 홍보, 일상 공유, 이벤트 안내 등" value={topicInput} onChange={(e, value) => this.onChangeTopic(e, value)} width="100%" padding="12px" />
                  </div> */}

                  {/* --- [NEW] 일체형 프롬프트 입력창 적용 --- */}
                  <div style={{ marginBottom: "28px" }}>
                      <div className="ai-prompt-container">
                          <div style={{ paddingLeft: "12px", fontSize: "18px", color: "#9ca3af" }}>💬</div>
                          <input 
                              type="text" 
                              className="ai-prompt-input" 
                              placeholder="어떤 스타일의 문구를 원하시나요? (예: 여름 신상품 홍보, 발랄하게)" 
                              value={topicInput} 
                              onChange={(e) => this.setState({ topicInput: e.target.value })}
                              onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.generateAICaption(); } }}
                          />
                          <button className="btn btn-black" style={{ height: "42px", padding: "0 24px", borderRadius: "8px", margin: "2px" }} onClick={this.generateAICaption}>
                              ✨ AI 생성하기
                          </button>
                      </div>
                      <div style={{ fontSize: "13px", color: "#64748b", paddingLeft: "6px", display: "flex", alignItems: "center", gap: "6px" }}>
                          <span style={{ color: "#00bfc2", fontSize: "15px" }}>💡</span> 
                          <span>입력 없이 <b>[✨ AI 생성하기]</b>를 누르시면 AI가 알아서 최적의 문구를 작성해 드립니다.</span>
                      </div>
                  </div>
    
                  <div className="ai-result-grid">
                      {(!aiRecommendations || aiRecommendations.length === 0) ? (
                          <div id="aiEmptyState" style={{ fontSize: "14px", textAlign: "center", padding: "40px", color: "#9ca3af", background: "white", borderRadius: "8px", border: "1px dashed #cbd5e1", wordBreak: "keep-all" }}>
                              위 입력창에 조건을 적거나, 빈칸 상태로 <b>[✨ AI 생성하기]</b>를 눌러보세요.
                          </div>
                      ) : (
                          aiRecommendations.map((rec, idx) => {
                              const isActive = selectedLabel === rec.label;
                              return (
                                  <div key={idx} className="ai-card" style={{ borderColor: isActive ? "var(--primary-mint)" : "var(--border-color)" }} onClick={() => this.useSuggestion(rec.label)}>
                                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "20px" }}>
                                          <div style={{ flex: 1 }}>
                                              <div style={{ display: "inline-block", fontSize: "12px", fontWeight: "700", color: "#0369a1", background: "#e0f2fe", padding: "4px 10px", borderRadius: "4px", marginBottom: "12px" }}>
                                                  ✨ 생성된 추천 문구 {idx + 1} : {rec.label}
                                              </div>
                                              <div style={{ fontSize: "14px", color: "#374151", lineHeight: 1.6, whiteSpace: "pre-wrap" }}>{rec.text}</div>
                                          </div>
                                          <button className="btn-apply" onClick={(e) => { e.stopPropagation(); this.useSuggestion(rec.label); }}>
                                              본문에 적용
                                          </button>
                                      </div>
                                  </div>
                              );
                          })
                      )}
                  </div>
                </div>
              </section>
    
              {/* SECTION 3: 해시태그 작성 */}
              <section className="card scroll-section" id="sec-hashtag" ref={el => { if(el) this.observer?.observe(el) }} style={{ padding: "24px" }}>
                
                {/* 헤더 영역 */}
                <div className="section-hashtag-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
                  <div className="section-title">
                    <span>
                      <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 6.99609H14" stroke="#333333" stroke-width="1.5" stroke-linecap="round"/>
                        <path d="M4 10.9961H14" stroke="#333333" stroke-width="1.5" stroke-linecap="round"/>
                        <path d="M6.31836 13.9961L7.22372 4.03716" stroke="#333333" stroke-width="1.5" stroke-linecap="round"/>
                        <path d="M10.8633 13.9961L11.7686 4.03716" stroke="#333333" stroke-width="1.5" stroke-linecap="round"/>
                      </svg>
                    </span> 
                    해시태그 작성
                    {/* <button className="icon-btn-purple" onClick={(e) => { e.stopPropagation(); this.toggleModal('hashtagSettings', true); }} title="설정 변경 안내">
                      <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.5" d="M19.7724 7.39596C19.7502 7.29675 19.7069 7.20343 19.6453 7.12231C19.5837 7.04119 19.5053 6.97417 19.4154 6.92577L17.2914 5.75473C17.1775 5.52521 17.0493 5.30299 16.9076 5.08936L16.9522 2.6763C16.9531 2.57508 16.9329 2.47479 16.8929 2.38168C16.853 2.28857 16.7942 2.20464 16.7202 2.13513C15.6626 1.18194 14.4119 0.465009 13.0522 0.0325761C12.9546 0.00231062 12.8516 -0.00701284 12.75 0.00522155C12.6485 0.017456 12.5507 0.0509698 12.4632 0.103549L10.3838 1.34557C10.1249 1.33669 9.87506 1.33669 9.61624 1.34557L7.53682 0.103549C7.44928 0.0509698 7.35151 0.017456 7.24997 0.00522155C7.14843 -0.00701284 7.04544 0.00231062 6.9478 0.0325761C5.58632 0.465338 4.33507 1.1856 3.2798 2.144C3.20514 2.21112 3.1458 2.29335 3.10578 2.38517C3.06575 2.47698 3.04597 2.57625 3.04776 2.6763L3.09238 5.08936C2.94959 5.30228 2.82465 5.52407 2.6997 5.75473L0.575656 6.92577C0.487054 6.97467 0.410099 7.04199 0.350035 7.12313C0.289971 7.20427 0.24821 7.29733 0.227598 7.39596C-0.075866 8.78144 -0.075866 10.2156 0.227598 11.6011C0.249766 11.7003 0.29311 11.7936 0.354698 11.8747C0.416286 11.9558 0.494681 12.0229 0.584581 12.0713L2.70863 13.2423C2.82249 13.4718 2.95066 13.694 3.09238 13.9077L3.04776 16.3207C3.04695 16.422 3.06713 16.5222 3.10705 16.6154C3.14698 16.7085 3.20578 16.7924 3.2798 16.8619C4.3374 17.8151 5.58812 18.532 6.9478 18.9645C7.04544 18.9947 7.14843 19.0041 7.24997 18.9918C7.35151 18.9796 7.44928 18.9461 7.53682 18.8935L9.61624 17.6515H10.3838L12.4721 18.8935C12.5807 18.9645 12.7081 19.0015 12.838 19C12.9106 18.9968 12.9825 18.9849 13.0522 18.9645C14.4137 18.5317 15.6649 17.8114 16.7202 16.853C16.7949 16.7859 16.8542 16.7037 16.8942 16.6119C16.9342 16.5201 16.954 16.4208 16.9522 16.3207L16.9076 13.9077C17.0504 13.6948 17.1754 13.473 17.3003 13.2423L19.4243 12.0713C19.5129 12.0224 19.5899 11.9551 19.65 11.8739C19.71 11.7928 19.7518 11.6997 19.7724 11.6011C20.0759 10.2156 20.0759 8.78144 19.7724 7.39596ZM18.4337 10.9889L16.4078 12.1068C16.2793 12.181 16.1766 12.2924 16.1133 12.4261C15.9665 12.7285 15.7964 13.0192 15.6046 13.2955C15.5232 13.4195 15.4797 13.5644 15.4797 13.7125L15.5154 16.0102C14.747 16.6606 13.8674 17.1684 12.9183 17.5095L10.9282 16.3207C10.8171 16.2565 10.6908 16.2228 10.5622 16.2232H10.5087C10.1701 16.2498 9.82991 16.2498 9.4913 16.2232C9.34498 16.2152 9.19942 16.2491 9.07185 16.3207L7.08167 17.5095C6.13377 17.1701 5.25434 16.6654 4.48462 16.0191L4.52032 13.7125C4.52026 13.5644 4.47685 13.4195 4.39537 13.2955C4.20684 13.0171 4.03691 12.7267 3.88667 12.4261C3.82078 12.2942 3.71868 12.1835 3.59216 12.1068L1.56628 10.9889C1.38773 10.0033 1.38773 8.99379 1.56628 8.0081L3.59216 6.89028C3.72068 6.81603 3.82341 6.70463 3.88667 6.57091C4.0335 6.26853 4.20357 5.97787 4.39537 5.7015C4.47685 5.57751 4.52026 5.43263 4.52032 5.28453L4.48462 2.9868C5.25298 2.33645 6.13264 1.82862 7.08167 1.48751L9.07185 2.6763C9.19905 2.74892 9.34489 2.78285 9.4913 2.77389C9.82991 2.74727 10.1701 2.74727 10.5087 2.77389C10.655 2.78183 10.8006 2.74797 10.9282 2.6763L12.9183 1.48751C13.8662 1.82698 14.7457 2.33168 15.5154 2.97793L15.4797 5.28453C15.4797 5.43263 15.5232 5.57751 15.6046 5.7015C15.7932 5.97992 15.9631 6.27035 16.1133 6.57091C16.1792 6.70286 16.2813 6.81358 16.4078 6.89028L18.4337 8.0081C18.6123 8.99379 18.6123 10.0033 18.4337 10.9889ZM10 4.53045C9.01154 4.53045 8.04527 4.82182 7.22339 5.36772C6.40152 5.91362 5.76094 6.68953 5.38267 7.59732C5.00441 8.50512 4.90543 9.50403 5.09827 10.4677C5.29111 11.4315 5.7671 12.3167 6.46605 13.0115C7.165 13.7063 8.05552 14.1794 9.02499 14.3711C9.99446 14.5628 10.9993 14.4644 11.9126 14.0884C12.8258 13.7124 13.6063 13.0756 14.1555 12.2586C14.7046 11.4416 14.9978 10.4811 14.9978 9.49852C14.9978 8.18091 14.4712 6.91726 13.5339 5.98557C12.5967 5.05387 11.3255 4.53045 10 4.53045ZM10 13.0471C9.29395 13.0471 8.60377 12.839 8.01671 12.4491C7.42966 12.0592 6.9721 11.5049 6.70191 10.8565C6.43172 10.2081 6.36102 9.49458 6.49877 8.80622C6.63651 8.11785 6.9765 7.48555 7.47575 6.98927C7.975 6.49298 8.61108 6.15501 9.30356 6.01809C9.99604 5.88116 10.7138 5.95144 11.3661 6.22002C12.0184 6.48861 12.5759 6.94345 12.9682 7.52701C13.3605 8.11058 13.5698 8.79667 13.5698 9.49852C13.5698 10.4397 13.1937 11.3423 12.5243 12.0078C11.8548 12.6733 10.9468 13.0471 10 13.0471Z" fill="#6D28D9"/>
                      </svg>
                    </button> */}
                  </div>
                  <div id="hashtag-setting-info" className="setting-link" style={{ cursor: 'pointer' }} onClick={(e) => { e.stopPropagation(); this.toggleModal('hashtagSettings', true); }}>
                    <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.5" d="M19.7724 7.39596C19.7502 7.29675 19.7069 7.20343 19.6453 7.12231C19.5837 7.04119 19.5053 6.97417 19.4154 6.92577L17.2914 5.75473C17.1775 5.52521 17.0493 5.30299 16.9076 5.08936L16.9522 2.6763C16.9531 2.57508 16.9329 2.47479 16.8929 2.38168C16.853 2.28857 16.7942 2.20464 16.7202 2.13513C15.6626 1.18194 14.4119 0.465009 13.0522 0.0325761C12.9546 0.00231062 12.8516 -0.00701284 12.75 0.00522155C12.6485 0.017456 12.5507 0.0509698 12.4632 0.103549L10.3838 1.34557C10.1249 1.33669 9.87506 1.33669 9.61624 1.34557L7.53682 0.103549C7.44928 0.0509698 7.35151 0.017456 7.24997 0.00522155C7.14843 -0.00701284 7.04544 0.00231062 6.9478 0.0325761C5.58632 0.465338 4.33507 1.1856 3.2798 2.144C3.20514 2.21112 3.1458 2.29335 3.10578 2.38517C3.06575 2.47698 3.04597 2.57625 3.04776 2.6763L3.09238 5.08936C2.94959 5.30228 2.82465 5.52407 2.6997 5.75473L0.575656 6.92577C0.487054 6.97467 0.410099 7.04199 0.350035 7.12313C0.289971 7.20427 0.24821 7.29733 0.227598 7.39596C-0.075866 8.78144 -0.075866 10.2156 0.227598 11.6011C0.249766 11.7003 0.29311 11.7936 0.354698 11.8747C0.416286 11.9558 0.494681 12.0229 0.584581 12.0713L2.70863 13.2423C2.82249 13.4718 2.95066 13.694 3.09238 13.9077L3.04776 16.3207C3.04695 16.422 3.06713 16.5222 3.10705 16.6154C3.14698 16.7085 3.20578 16.7924 3.2798 16.8619C4.3374 17.8151 5.58812 18.532 6.9478 18.9645C7.04544 18.9947 7.14843 19.0041 7.24997 18.9918C7.35151 18.9796 7.44928 18.9461 7.53682 18.8935L9.61624 17.6515H10.3838L12.4721 18.8935C12.5807 18.9645 12.7081 19.0015 12.838 19C12.9106 18.9968 12.9825 18.9849 13.0522 18.9645C14.4137 18.5317 15.6649 17.8114 16.7202 16.853C16.7949 16.7859 16.8542 16.7037 16.8942 16.6119C16.9342 16.5201 16.954 16.4208 16.9522 16.3207L16.9076 13.9077C17.0504 13.6948 17.1754 13.473 17.3003 13.2423L19.4243 12.0713C19.5129 12.0224 19.5899 11.9551 19.65 11.8739C19.71 11.7928 19.7518 11.6997 19.7724 11.6011C20.0759 10.2156 20.0759 8.78144 19.7724 7.39596ZM18.4337 10.9889L16.4078 12.1068C16.2793 12.181 16.1766 12.2924 16.1133 12.4261C15.9665 12.7285 15.7964 13.0192 15.6046 13.2955C15.5232 13.4195 15.4797 13.5644 15.4797 13.7125L15.5154 16.0102C14.747 16.6606 13.8674 17.1684 12.9183 17.5095L10.9282 16.3207C10.8171 16.2565 10.6908 16.2228 10.5622 16.2232H10.5087C10.1701 16.2498 9.82991 16.2498 9.4913 16.2232C9.34498 16.2152 9.19942 16.2491 9.07185 16.3207L7.08167 17.5095C6.13377 17.1701 5.25434 16.6654 4.48462 16.0191L4.52032 13.7125C4.52026 13.5644 4.47685 13.4195 4.39537 13.2955C4.20684 13.0171 4.03691 12.7267 3.88667 12.4261C3.82078 12.2942 3.71868 12.1835 3.59216 12.1068L1.56628 10.9889C1.38773 10.0033 1.38773 8.99379 1.56628 8.0081L3.59216 6.89028C3.72068 6.81603 3.82341 6.70463 3.88667 6.57091C4.0335 6.26853 4.20357 5.97787 4.39537 5.7015C4.47685 5.57751 4.52026 5.43263 4.52032 5.28453L4.48462 2.9868C5.25298 2.33645 6.13264 1.82862 7.08167 1.48751L9.07185 2.6763C9.19905 2.74892 9.34489 2.78285 9.4913 2.77389C9.82991 2.74727 10.1701 2.74727 10.5087 2.77389C10.655 2.78183 10.8006 2.74797 10.9282 2.6763L12.9183 1.48751C13.8662 1.82698 14.7457 2.33168 15.5154 2.97793L15.4797 5.28453C15.4797 5.43263 15.5232 5.57751 15.6046 5.7015C15.7932 5.97992 15.9631 6.27035 16.1133 6.57091C16.1792 6.70286 16.2813 6.81358 16.4078 6.89028L18.4337 8.0081C18.6123 8.99379 18.6123 10.0033 18.4337 10.9889ZM10 4.53045C9.01154 4.53045 8.04527 4.82182 7.22339 5.36772C6.40152 5.91362 5.76094 6.68953 5.38267 7.59732C5.00441 8.50512 4.90543 9.50403 5.09827 10.4677C5.29111 11.4315 5.7671 12.3167 6.46605 13.0115C7.165 13.7063 8.05552 14.1794 9.02499 14.3711C9.99446 14.5628 10.9993 14.4644 11.9126 14.0884C12.8258 13.7124 13.6063 13.0756 14.1555 12.2586C14.7046 11.4416 14.9978 10.4811 14.9978 9.49852C14.9978 8.18091 14.4712 6.91726 13.5339 5.98557C12.5967 5.05387 11.3255 4.53045 10 4.53045ZM10 13.0471C9.29395 13.0471 8.60377 12.839 8.01671 12.4491C7.42966 12.0592 6.9721 11.5049 6.70191 10.8565C6.43172 10.2081 6.36102 9.49458 6.49877 8.80622C6.63651 8.11785 6.9765 7.48555 7.47575 6.98927C7.975 6.49298 8.61108 6.15501 9.30356 6.01809C9.99604 5.88116 10.7138 5.95144 11.3661 6.22002C12.0184 6.48861 12.5759 6.94345 12.9682 7.52701C13.3605 8.11058 13.5698 8.79667 13.5698 9.49852C13.5698 10.4397 13.1937 11.3423 12.5243 12.0078C11.8548 12.6733 10.9468 13.0471 10 13.0471Z" fill="#6b7280"></path></svg>  
                    설정 기준: 동시생성 {is_auto_hashtag_on ? "ON" : "OFF"} ({hashtag_setting_count}개)
                  </div>
                </div>

                {/* 적용될 해시태그 영역 (DnD) */}
                <div style={{ marginBottom: "16px" }}>
                  <div className="hashtag-sub-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
                    <div id="hashtag-title" style={{ fontSize: "16px", fontWeight: "bold", color: "#333333", display: "flex",  alignItems: "center", gap: "4px" }}>
                      적용될 해시태그 <span style={{ color: this.state.tags.length > 30 ? "#ef4444" : "#6b7280", fontSize: "14px", fontWeight: "normal", lineHeight: "1" }}>({this.state.tags.length}/30)</span>
                    </div>
                    {/* 🪄 AI 추천 버튼 */}
                    <button 
                      id="hashtag-ai-button"
                      className="btn btn-black"
                      onClick={this.generateAIHashtags}
                      // style={{ 
                      //   width: "auto", padding: "0px 24px", height: "42px", background: "#0f172a", color: "white", 
                      //   border: "none", borderRadius: "8px", fontSize: "14px", fontWeight: "bold", 
                      //   cursor: "pointer" 
                      // }}
                      >
                      🪄 본문 맞춤 AI 해시태그 추천받기
                    </button>
                  </div>
                  
                  <div style={{ 
                    minHeight: "70px", 
                    border: "1px dashed #06b6d4", 
                    borderRadius: "8px", 
                    padding: "16px", 
                    background: "#f8fafc",
                    display: "flex", 
                    flexWrap: "wrap", 
                    gap: "8px",
                    alignItems: "center",
                    justifyContent: this.state.tags.length === 0 ? "center" : "flex-start"
                  }}>
                    {this.state.tags.length === 0 ? (
                      <span style={{ color: "#9ca3af", fontSize: "14px" }}>아래에서 태그를 추가해 보세요.</span>
                    ) : (
                      <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={this.handleDragEnd}>
                        <SortableContext items={this.state.tags} strategy={rectSortingStrategy}>
                          {this.state.tags.map((t, i) => (
                            <SortableTag key={t} id={t} onRemove={() => this.removeTagAt(i)}>{t}</SortableTag>
                          ))}
                        </SortableContext>
                      </DndContext>
                    )}
                  </div>
                </div>

                {/* ⌨️ 수동 입력 폼 */}
                <div style={{ display: "flex", gap: "8px", marginBottom: "24px" }}>
                  {/* <input 
                    type="text" 
                    value={this.state.tagInput || ""} 
                    onChange={(e) => this.setState({ tagInput: e.target.value })}
                    onKeyDown={e => {this.handleTagKeyDown(e)}}
                    placeholder="# 수동 입력 후 Enter 또는 우측 버튼"
                    style={{ flex: 1, padding: "12px 16px", border: "1px solid #d1d5db", borderRadius: "8px", fontSize: "14px", outline: "none" }}
                  /> */}
                  <TextInput
                      ref={this.inputHashtagRef} // ref 연결
                      type="text" 
                      placeholder="# 수동 입력 후 Enter 또는 '추가' 버튼"
                      value={this.state.inputHashtagValue || ""} 
                      onChange={(e) => {
                        const value = e.target.value;
                        // 맥북에서 조합 중 스페이스바를 누르면, 글자가 정상적으로 완성된 후 
                        // value에 공백이 포함된 채로 들어옵니다. (예: "태그 ")
                        if (value.includes(' ') && !value.trim().includes(' ')) {
                            // addTag 내부에서 trim()을 통해 공백이 제거되므로 깔끔하게 처리됩니다.
                            this.isComposing = false;
                            this.addTag(value); 
                        } else {
                            this.setState({ inputHashtagValue: this.sanitizeHashtag(value) });
                        }
                      }}
                      onKeyDown={e => {this.handleTagKeyDown(e)}}
                      onCompositionStart={this.handleComposition}
                      onCompositionEnd={this.handleComposition}
                      height="42px"
                  />
                  <button 
                    onClick={() => this.addTag(this.state.inputHashtagValue)}
                    className="btn btn-outline"
                    // style={{ minWidth: "82px", padding: "0 24px", height: "42px", background: "white", border: "1px solid #d1d5db", borderRadius: "8px", fontSize: "14px", fontWeight: "bold", cursor: "pointer" }}
                  >
                    추가
                  </button>
                </div>

                {/* 고정 태그 (클릭 시 위로 올라감) */}
                <div style={{ paddingTop: "20px", borderTop: "1px dashed #e5e7eb" }}>
                  <div style={{ fontSize: "13px", fontWeight: "bold", color: "#6b7280", marginBottom: "12px" }}>
                    📌 자주 쓰는 태그 (클릭하여 위로 추가)
                  </div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}>
                    <button onClick={() => this.toggleModal('addTag', true)} className="phrase-chip chip-new">
                      + 즐겨찾는 태그 추가
                    </button>
                    
                    {/* 고정 태그 맵핑 */}
                    {fixedTags.map((tag, idx) => (
                      <button 
                        className="phrase-chip"
                        key={`fixed-${idx}`} 
                        onClick={() => this.addTag(tag.tag_name)} // 여긴 이미 정상
                      >
                        {tag.tag_name} 
                        <span className="chip-delete" onClick={(e) => { e.stopPropagation(); this.removePhraseHashtag(idx); }}>×</span>
                      </button>
                    ))}
                  </div>
                </div>

              </section>
    
            </main>
    
            {/* --- [ASIDE] 우측 미리보기 영역 --- */}
            <aside className="preview-fixed-area">
              <div style={{ fontWeight: '800', color: 'var(--deep-navy)', marginBottom: '16px', fontSize: '15px' }}>📱 인스타그램 미리보기</div>
              
              <div className="insta-frame">
                <div style={{ padding: '14px', display: 'flex', alignItems: 'center', borderBottom: '1px solid #efefef' }}>
                  <div style={{ width: '32px', height: '32px', borderRadius: '50%', marginRight: '12px', background: 'var(--primary-mint)', overflow: 'hidden' }}>
                    {
                      previewAccount.profile_picture_url
                        ? <img src={previewAccount.profile_picture_url} alt="Profile" style={{ width: "100%", height: "100%" }} onError={(e) => { e.currentTarget.style.display = 'none'; }} />
                        : null
                    }
                  </div>
                  {/* 여기서 '계정 미연동'이 출력됩니다 */}
                  <div style={{ fontWeight: '600', fontSize: '13px' }}>{previewAccount.title}</div>
                </div>
                
                <div style={{ position: "relative", width: '100%', aspectRatio: (this.state.currentRatio ? this.state.currentRatio : "1/1"), backgroundColor: '#f3f4f6', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                  {currentImg ? (
                    <img src={currentImg} style={{ width: '100%', height: '100%', objectFit: 'cover' }} alt="미리보기" />
                  ) : (
                    <div style={{ color: '#9ca3af', fontSize: '13px' }}>이미지 없음</div>
                  )}

                  {hasSlides && (
                    <div style={{ position: "absolute", bottom: 10, left: "50%", transform: "translateX(-50%)", display: "flex", gap: "6px" }}>
                      {imgs.map((_, i) => (
                        <div key={i} onClick={() => this.setSlide(i)} style={{ width: 6, height: 6, borderRadius: "50%", background: i === currentIdx ? "#fff" : "rgba(255,255,255,0.5)", cursor: "pointer" }} />
                      ))}
                    </div>
                  )}
                  {hasSlides && (
                      <>
                          <button onClick={this.previousSlide} style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", background: "rgba(0,0,0,0.5)", color: "white", border: "none", borderRadius: "50%", width: 32, height: 32, cursor: "pointer" }}>‹</button>
                          <button onClick={this.nextSlide} style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", background: "rgba(0,0,0,0.5)", color: "white", border: "none", borderRadius: "50%", width: 32, height: 32, cursor: "pointer" }}>›</button>
                      </>
                  )}
                </div>
                
                <div style={{ padding: '16px', fontSize: '14px', color: '#262626', lineHeight: '1.5', maxHeight: '350px', overflowY: 'auto' }}>
                  <div style={{ marginBottom: '8px' }}>
                    {/* 본문 앞에도 '계정 미연동'이 출력됩니다 */}
                    <span style={{ fontWeight: '600', marginRight: '6px' }}>{previewAccount.title}</span>
                    <span style={{ whiteSpace: 'pre-line' }}>{caption || '미리보기 문구가 여기에 표시됩니다.'}</span>
                  </div>
                  <div style={{ color: '#00376b', wordBreak: 'break-all', marginTop: '10px', whiteSpace: 'pre-wrap' }}>
                    {tags.length > 0 ? tags.join(' ') : ''}
                  </div>
                </div>
              </div>
            </aside>
    
          </div>
    
          {/* --- [NEW MODALS] HTML에서 추가된 모달들 --- */}
          {/* {modals.styleConfig && (
              <div className="modal-overlay open" onClick={(e) => { if(e.target.className.includes('modal-overlay')) this.toggleModal('styleConfig', false); }}>
                  <div className="modal-box">
                      <div className="modal-title">🤖 카피라이터 설정</div>
                      <p style={{ color: '#6b7280', fontSize: '14px', marginBottom: '20px' }}>우리 브랜드에 맞는 톤앤매너와 타겟을 설정하세요.</p>
                      <div style={{ background: '#f8fafc', border: '1px dashed #cbd5e1', padding: '40px', textAlign: 'center', borderRadius: '8px', color: '#94a3b8' }}>
                          (상세 프롬프트 설정 UI 영역)
                      </div>
                      <div style={{ textAlign: 'right', marginTop: '24px' }}>
                          <button className="btn btn-outline" onClick={() => this.toggleModal('styleConfig', false)}>취소</button>
                          <button className="btn btn-primary" onClick={() => this.toggleModal('styleConfig', false)}>저장하기</button>
                      </div>
                  </div>
              </div>
          )} */}

          {modals.captionSettings && (
              <div className="modal-overlay open" onClick={(e) => { if(e.target.className.includes('modal-overlay')) this.toggleModal('captionSettings', false); }}>
                  <div className="modal-box" style={{ width: '420px', textAlign: 'center' }}>
                      <div className="modal-title">설정 변경 안내</div>
                      <p style={{ color: '#64748b', lineHeight: 1.6, marginBottom: '24px' }}>
                          문구 자동 생성 여부와 한 번에 생성할 개수는<br/>
                          <b>[Ai 자동 환경설정]</b> 메뉴에서 언제든 변경할 수 있습니다.<br/><br/>
                          지금 설정 화면으로 이동하시겠습니까?
                      </p>
                      <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                          <button className="btn btn-outline" style={{ flex: 1 }} onClick={() => this.toggleModal('captionSettings', false)}>취소</button>
                          <button className="btn btn-primary" style={{ flex: 1 }} onClick={() => this.goToSettings('captionSettings')}>설정으로 이동</button>
                      </div>
                  </div>
              </div>
          )}

          {modals.hashtagSettings && (
              <div className="modal-overlay open" onClick={(e) => { if(e.target.className.includes('modal-overlay')) this.toggleModal('hashtagSettings', false); }}>
                  <div className="modal-box" style={{ width: '420px', textAlign: 'center' }}>
                      <div className="modal-title">설정 변경 안내</div>
                      <p style={{ color: '#64748b', lineHeight: 1.6, marginBottom: '24px' }}>
                          해시태그 자동 생성 여부와 추천 개수는<br/>
                          <b>[Ai 자동 환경설정]</b> 메뉴에서 언제든 변경할 수 있습니다.<br/><br/>
                          지금 설정 화면으로 이동하시겠습니까?
                      </p>
                      <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                          <button className="btn btn-outline" style={{ flex: 1 }} onClick={() => this.toggleModal('hashtagSettings', false)}>취소</button>
                          <button className="btn btn-primary" style={{ flex: 1 }} onClick={() => this.goToSettings('hashtagSettings')}>설정으로 이동</button>
                      </div>
                  </div>
              </div>
          )}

          {modals.phrase && (
              <div className="modal-overlay open" onClick={(e) => { if(e.target.className.includes('modal-overlay')) this.toggleModal('phrase', false); }}>
                  <div className="modal-box">
                      <div className="modal-title">즐겨찾는 문구 추가</div>
                      <input type="text" className="form-control" placeholder="버튼 이름 (예: 문의안내)" style={{ marginBottom: '12px' }} value={this.state.phraseTitleInput} onChange={(e) => this.setState({ phraseTitleInput: e.target.value })} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); document.getElementById('phraseContentInputModal').focus(); } }} />
                      <textarea id="phraseContentInputModal" className="form-control" rows="3" placeholder="삽입될 문구 내용 (Shift+Enter로 줄바꿈, Enter로 저장)" value={this.state.phraseContentInput} onChange={(e) => this.setState({ phraseContentInput: e.target.value })} onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); this.addNewPhrase(); } }} />
                      <div className="flexBox" style={{ justifyContent: 'flex-end', textAlign: 'right', marginTop: '20px', gap: '12px' }}>
                          <button className="btn btn-outline" onClick={() => this.toggleModal('phrase', false)}>취소</button>
                          <button className="btn btn-primary" onClick={this.addNewPhrase}>추가</button>
                      </div>
                  </div>
              </div>
          )}

          {modals.addTag && (
              <div className="modal-overlay open" onClick={(e) => { if(e.target.className.includes('modal-overlay')) this.toggleModal('addTag', false); }}>
                  <div className="modal-box">
                      <div className="modal-title">즐겨찾는 태그 추가</div>
                      <p style={{ fontSize: '13px', color: '#64748b', marginBottom: '12px' }}># 기호를 쓰지 않아도 자동으로 붙습니다. (Enter를 눌러 저장하세요)</p>
                      <input type="text" className="form-control" placeholder="예: 트렌드" value={this.state.newFixedTagInput} onChange={(e) => this.setState({ newFixedTagInput: e.target.value })} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); this.addNewFixedTag(); } }} />
                      <div style={{ display: "flex", justifyContent: "right", marginTop: '20px', gap: "8px" }}>
                          <button className="btn btn-outline" onClick={() => this.toggleModal('addTag', false)}>취소</button>
                          <button className="btn btn-primary" onClick={this.addNewFixedTag}>추가</button>
                      </div>
                  </div>
              </div>
          )}
        </div>
          {/* --- [EXISTING MODALS] 기존 모달 유지 --- */}
          {this.state.imageModalOpen && (
            <div className="modal-overlay open" style={{ zIndex: 9999 }} onClick={(e) => { if (e.target.className.includes("modal-overlay")) this.closeImageModal(); }}>
              <div id="imageSelectModal" className="modal-box" style={{ maxWidth: 540, width: "100%", padding: 30 }}>
                  <h3 style={{ marginBottom: 20, fontSize: '20px', fontWeight: 800 }}>이미지를 어떻게 만들까요?</h3>
                  <div className="image-source-options" style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 15, margin: "20px 0" }}>
                    {[
                      { key: "upload", label: "직접 올리기", sub: "내 컴퓨터에서 선택", icon: "📁" },
                      { key: "product", label: "상품 사용", sub: "쇼핑몰 상품 선택", icon: "🛍️" },
                      { key: "ai", label: "AI 생성", sub: "AI로 이미지 만들기", icon: "🤖" },
                      { key: "template", label: "템플릿 사용", sub: "디자인 템플릿 적용", icon: "🎨" },
                    ].map((opt) => (
                      <div key={opt.key} onClick={() => this.handleImageSource(opt.key)} style={{ padding: 20, border: "1px solid #dbdbdb", borderRadius: 8, cursor: "pointer", textAlign: "center" }}>
                        <div style={{ fontSize: 32, marginBottom: 10 }}>{opt.icon}</div>
                        <h4 style={{ margin: 0, color: 'var(--deep-navy)' }}>{opt.label}</h4>
                        <p style={{ fontSize: 12, color: "#8e8e8e", margin: 0, marginTop: '6px' }}>{opt.sub}</p>
                      </div>
                    ))}
                  </div>
              </div>
            </div>
          )}
          
          {/* {this.state.imageModalOpen && (
            <div className="modal-overlay open" style={{ zIndex: 9999 }} onClick={(e) => { if (e.target.className.includes("modal-overlay")) this.closeImageModal(); }}>
              <div id="imageSelectModal" className="modal-box" style={{ maxWidth: 540, width: "100%", padding: 30 }}>
                  <h3 style={{ marginBottom: 20, fontSize: '20px', fontWeight: 800 }}>이미지를 어떻게 만들까요?</h3>
                  <div className="image-source-options" style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 15, margin: "20px 0" }}>
                    {[
                      // icon 값에 FontAwesome 클래스명 할당
                      { key: "upload", label: "직접 올리기", sub: "내 컴퓨터에서 선택", icon: "fas fa-cloud-upload-alt" },
                      { key: "product", label: "상품 사용", sub: "쇼핑몰 상품 선택", icon: "fas fa-shopping-bag" },
                      { key: "ai", label: "AI 생성", sub: "AI로 이미지 만들기", icon: "fas fa-robot" },
                      { key: "template", label: "템플릿 사용", sub: "디자인 템플릿 적용", icon: "fas fa-palette" },
                    ].map((opt) => (
                      <div key={opt.key} onClick={() => this.handleImageSource(opt.key)} style={{ padding: 20, border: "1px solid #dbdbdb", borderRadius: 8, cursor: "pointer", textAlign: "center" }}>
                        <div style={{ fontSize: 32, marginBottom: 10, color: 'var(--primary-mint)' }}>
                            <i className={opt.icon}></i>
                        </div>
                        <h4 style={{ margin: 0, color: 'var(--deep-navy)' }}>{opt.label}</h4>
                        <p style={{ fontSize: 12, color: "#8e8e8e", margin: 0, marginTop: '6px' }}>{opt.sub}</p>
                      </div>
                    ))}
                  </div>
              </div>
            </div>
          )} */}

          {/* 연결한 계정을 선택하는 팝업 */}
          {this.state.show_account_connect_popup && (
            <PopupFrameV2
              className={"account-connect-popup"}
              maxWidth={"950px"}
              onClose={() => this.setState({ show_account_connect_popup: false })}
            >
              <div className="instagram_account_page" style={{ paddingBottom: 52}}>
                <h5 style={{ marginBottom: 20 }}>연결할 인스타그램 계정을 선택해주세요</h5>
                {(this.state.add_account_list || []).map((account) => (
                    <div className="instagram-accounts" key={account.token_id}>
                      {(Array.isArray(account.instagram_account_list)
                        ? account.instagram_account_list
                        : []
                      )
                        .filter((instagram) => instagram && instagram.instagram_access_token_seq)
                        .map((instagram) => (
                          <div
                            className="account-card"
                            key={instagram.instagram_access_token_seq}
                            onClick={(e) => {
                              // 체크박스나 라벨 자체를 클릭했을 때는 중복 실행 방지
                              if (e.target.closest('input[type="checkbox"], label')) return;
                              
                              let selected_account_list = [...this.state.selected_account_list];
                              const v = String(instagram.instagram_access_token_seq);

                              if (selected_account_list.includes(v)) {
                                selected_account_list = selected_account_list.filter(seq => seq !== v);
                              } else {
                                selected_account_list.push(v);
                              }

                              this.setState({ selected_account_list });
                            }}
                            style={{
                              display: "flex",
                              gap: "18px",
                              cursor: "pointer",
                              userSelect: "none",
                              WebkitUserSelect: "none",
                              msUserSelect: "none",
                              marginBottom: "12px"
                            }}
                          >
                            <CheckBox
                              id={String(instagram.instagram_access_token_seq)}
                              value={String(instagram.instagram_access_token_seq)}
                              checked={this.state.selected_account_list.includes(
                                String(instagram.instagram_access_token_seq)
                              )}
                              onChangeCheck={(e) => {
                                let selected_account_list = [...this.state.selected_account_list];
                                const v = String(instagram.instagram_access_token_seq);

                                if (selected_account_list.includes(v)) {
                                  selected_account_list = selected_account_list.filter(seq => seq !== v);
                                } else {
                                  selected_account_list.push(v);
                                }
                                this.setState({ selected_account_list });
                              }}
                            />

                            <div className="account-wrapper" style={{ display: 'flex', alignItems: 'center' }}>
                              <div className="account-left" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <div className="account-avatar" style={{ width: '32px', height: '32px', borderRadius: '50%', overflow: 'hidden', background: '#eee' }}>
                                  {!!instagram.profile_picture_url && (
                                    <img src={instagram.profile_picture_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                  )}
                                </div>
                                <div className="account-info">
                                  <div className="account-username" style={{ fontWeight: '600', color: 'var(--deep-navy)' }}>
                                    {instagram.username || "(username 없음)"}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                ))}
              </div>

              <div
                style={{
                  display: "flex",
                  width: "calc(100% - 40px)",
                  justifyContent: "flex-end",
                  position: "absolute",
                  bottom: "20px",
                }}
              >
                <button className="btn btn-primary"
                  onClick={() => {
                    this.updateSelectedAccountsUseYn();
                  }}
                >
                  연결하기
                </button>
              </div>
            </PopupFrameV2>
          )}
          {this.state.confirm_dialog_show_state && <ConfirmDialogV2 content={this.state.confirm_dialog_content} button_list={this.state.confirm_dialog_button_list} popup_close={()=>{this.setState({confirm_dialog_show_state: false})}} />}
          {this.state.save_dialog_show_state && <SaveDialogV2 content={this.state.save_dialog_content} button_list={this.state.save_dialog_button_list} />}
          {this.state.basic_dialog_show_state && <BasicDialogV2 content={this.state.basic_dialog_content} button_list={this.state.basic_dialog_button_list} />}
          {this.state.warning_dialog_show_state && <WarningDialog content={this.state.warning_dialog_content} button_list={this.state.warning_dialog_button_list} />}
          {/* {this.state.show_robo_img_popup && <RoboImageStudioTabs onClose={e => {this.setState({show_robo_img_popup:false})}} sendRoboImg={(img, seq) => {
              this.setState({
                save_dialog_show_state: true,
                save_dialog_content: "이미지를 적용 중입니다."
              });
              
              const config = { headers: { 'Content-Type': 'application/json' } };
              const body = { image_url: img, ratio: this.state.currentRatio ? this.state.currentRatio : "1/1" };
              http.post("/rest/shop/instagram/resizeUrlImg", body, config).then(res => {
                  this.applyAIImg(res.data.org_img_path, seq);
                  this.setState({show_robo_img_popup:false, save_dialog_show_state: false});
              });
          }} defaultTab="GENERATE" ratio={this.state.currentRatio || "1/1"} 
             service_type="01014"
          />} */}
          {this.state.show_robo_img_popup && (
              <AiImageStudioWorkflowClass
                  view_mode="popup"
                  ai_response_type="IMAGE"
                  onClose={() => {
                      this.setState({ show_robo_img_popup: false });
                  }}
                  onApplyRule={(result) => {
                      const img = result.appliedImage || result.appliedValue || "";

                      if (!img) {
                          window.alert("적용할 이미지가 없습니다.");
                          return;
                      }

                      this.setState({
                          save_dialog_show_state: true,
                          save_dialog_content: "이미지를 적용 중입니다."
                      });

                      const config = {
                          headers: { 'Content-Type': 'application/json' }
                      };

                      const body = {
                          image_url: img,
                          ratio: this.state.currentRatio ? this.state.currentRatio : "1/1"
                      };

                      http.post("/rest/shop/instagram/resizeUrlImg", body, config)
                          .then((res) => {
                              this.applyAIImg(res.data.org_img_path, undefined);
                              this.setState({
                                  show_robo_img_popup: false,
                                  save_dialog_show_state: false
                              });
                          })
                          .catch((e) => {
                              console.error(e);
                              this.setState({
                                  save_dialog_show_state: false
                              });
                              window.alert("이미지를 적용할 수 없어요.");
                          });
                  }}
                  ratio={this.state.currentRatio || "1/1"}
                  service_type="01014"
              />
          )}
          {this.state.show_add_product_popup && <SearchProductPopup title={"상품 추가"} select_type={"radio"} selected_product_list={this.state.selected_rp_product_list || []} onClose={() => {this.setState({show_add_product_popup:false})}} onSubmit={this.onClickAddProductbtn.bind(this)} submit_btn_name={"선택 상품 추가"} />}
          {this.state.show_design_template_popup && <InstagramTemplateEditor onClose={() => {this.setState({show_design_template_popup:false})}} onSubmit={this.applydDesign.bind(this)} event_seq={this.state.selected_event_seq} ratio={this.state.currentRatio ? this.state.currentRatio.replace("/", ":") : "1:1"} />}
          {this.state.isSizeModalOpen && (
            <ModalSizeSelect
              isOpen={this.state.isSizeModalOpen}
              onSelect={(ratio) => {
                this.setState({
                  isSizeModalOpen: false,
                  currentRatio: ratio,
                  imageModalOpen: true
                });
              }}
            />
          )}
    
          <AICopywriterModal 
            selectedId={this.state.copywriter_preset_seq}
            isOpen={modals.styleConfig} 
            onClose={() => this.setState({ modals: { ...modals, styleConfig: false } })} 
            onApply={(selectedId) => this.setState({ modals: { ...modals, styleConfig: false } , copywriter_preset_seq: selectedId })}
          />
          <input type="file" ref={this.fileInputRef} accept="image/*" style={{ display: "none" }} />
      </div>
      </>
    );
  }
}